<div class="plant-model-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
        <a
          class="breadcrumb-link"
          [routerLink]="breadcrumItem.Url"
          [id]="breadcrumItem.id"
          (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
          >{{lang.getTransalatedValue(breadcrumItem.text)}}</a
        >
      </li>
    </ul>
    <div class="top-box-content">
      <h1 class="main-title">{{langObj ? langObj?.PlantModel : ('PlantModel' | translate)}}</h1>
      <ngx-spinner
        bdColor="rgba(0, 0, 0, 0.8)"
        template=" <img src='assets/images/spinner.gif' />"
      ></ngx-spinner>

      <button
        *ngIf="IsWrite"
        (click)="openaddNewPlantItemModel()"
        class="add-btn"
        pTooltip="Add New Group"
        tooltipPosition="bottom"
      >
        <img src="assets/images/add.png" alt="" width="20px" height="20px" />
      </button>
      <!-- <button *ngIf="IsWrite" mat-flat-button class="btn-add-item" (click)="openaddNewPlantItemModel()">
        <span class="btn-icon">
          <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.18143 5.4235H5.6525V8.9235H4.47619V5.4235H0.947266V4.25684H4.47619V0.756836H5.6525V4.25684H9.18143V5.4235Z"
              fill="white" />
          </svg>
        </span>
        <span class="btn-text">Add New Group</span>
      </button>  -->

      <div class="content-top-row content-top-row-order-processing">
        <mat-form-field
          appearence="fill"
          class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="width: 400px; margin-left: 400px"
        >
          <input
            matInput
            placeholder="{{langObj ? langObj?.Search : ('Search' | translate)}}"
            (keyup)="applyFilter($event)"
            autocomplete="off"
          />
        </mat-form-field>

        <div class="d-flex align-items-center">
          <a
            [disabled]="!IsWrite"
            mat-flat-button
            color="accent"
            class="btn-accent mx-15px"
            href="../../../assets/xlsx/Plant_Configuration.xlsx"
          >
          {{langObj ? langObj?.Sample : ('Sample' | translate)}}</a
          >

          <div class="dropzone">
            <div
              class="custom-dropzone"
              ngx-dropzone
              [disabled]="!IsWrite"
              (change)="onReadExcel($event)"
            >
              <div>
                <ngx-dropzone-preview>
                  <ngx-dropzone-label>{{langObj ? langObj?.Upload : ('Upload' | translate)}}</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </div>
            </div>
          </div>
          <!-- <button mat-flat-button color="accent" class="btn-accent"> Upload</button> -->
        </div>
      </div>
    </div>
  </div>
  <div
    class="wrapper-box wrapper-box-shadow table-wrapper"
    *ngIf="plantModelData !== undefined"
  >
    <table
      mat-table
      [dataSource]="plantModelData"
      class="basic-table plant-model-table"
      matSort
    >
      <!-- groupID Column -->
      <ng-container matColumnDef="EGId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="header-min-width"
        >
          <p class="header-text">{{langObj ? langObj?.GroupID : ('GroupID' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.EGId }}</td>
      </ng-container>

      <!-- groupDescription Column -->
      <ng-container matColumnDef="EGDesc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{langObj ? langObj?.GroupDescription : ('GroupDescription' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.EGDesc }}</td>
      </ng-container>

      <!-- remarks Column -->
      <ng-container matColumnDef="Remarks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.Remarks }}</td>
      </ng-container>

      <!-- groupOrder Column -->
      <ng-container matColumnDef="GrpOrder">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="grp-order">
          <p class="header-text">{{langObj ? langObj?.GroupOrder : ('GroupOrder' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.GrpOrder }}</td>
      </ng-container>

      <!-- active Column -->
      <ng-container matColumnDef="IsActive">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="header-min-width"
        >
          <p class="header-text">{{langObj ? langObj?.InActive : ('InActive' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.IsActive }}</td>
      </ng-container>
      <!-- NofLicense Column -->
      <ng-container matColumnDef="NoOfLicense">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="header-min-width"
        >
          <p class="header-text">{{langObj ? langObj?.NoOfLicense : ('NoOfLicense' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.NoOfLic }}</td>
      </ng-container>
      <ng-container matColumnDef="CreatedBy">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="created-By"
        >
          <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.CreatedBy }}</td>
      </ng-container>
      <!-- createdOn Column -->
      <ng-container matColumnDef="CreatedOn">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="created-on"
        >
          <p class="header-text">{{langObj ? langObj?.CreatedOn : ('CreatedOn' | translate)}}</p>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.CreatedOn | date: "y/MM/dd h:mm:ss" }}
        </td>
      </ng-container>

      <!-- plantModelActions Column -->
      <ng-container matColumnDef="plantModelActions">
        <th mat-header-cell *matHeaderCellDef>
          <p class="header-text">{{langObj ? langObj?.Actions : ('Actions' | translate)}}</p>
        </th>

        <td mat-cell *matCellDef="let element" class="row-action-btns-column">
          <div class="row-action-btns" style="min-width: 78px">
            <button
              *ngIf="IsWrite"
              mat-icon-button
              class="edit-btn"
              aria-label="Edit Group"
              (click)="openEditPlantItemModel(element)"
              pTooltip="Edit"
              tooltipPosition="top"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                  fill="white"
                />
              </svg>
            </button>
            <!-- <button mat-icon-button class="node-control-btn node-delete" aria-label="delete item"
            (click)="deleteGroup(element.EGId)" pTooltip="Delete Group" tooltipPosition="top">
            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.35547 0.9375H5.60547L5.10547 0.4375H2.60547L2.10547 0.9375H0.355469V1.9375H7.35547V0.9375ZM0.855469 8.4375C0.855469 8.70272 0.960826 8.95707 1.14836 9.14461C1.3359 9.33214 1.59025 9.4375 1.85547 9.4375H5.85547C6.12069 9.4375 6.37504 9.33214 6.56258 9.14461C6.75011 8.95707 6.85547 8.70272 6.85547 8.4375V2.4375H0.855469V8.4375Z"
                fill="white" />
            </svg>
      </button> -->
            <button
              *ngIf="IsAccess"
              mat-icon-button
              class="tree-view-btn"
              aria-label="View Row Tree"
              (click)="openPlantGroupModel(element)"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 8.75V5.25H4.375V6.125H2.625V3.5H10.5V0H0V3.5H1.75V12.25H4.375V14H14V10.5H4.375V11.375H2.625V7H4.375V8.75H14Z"
                  fill="white"
                />
              </svg>
            </button>
            <button
              *ngIf="IsWrite"
              mat-icon-button
              class="edit-btn"
              aria-label="Edit Group"
              (click)="ExportTOExcel(element)"
              pTooltip="Download"
              tooltipPosition="top"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="plantModelColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: plantModelColumns"></tr>
    </table>
    <mat-paginator
      class="basic-paginataor"
      [pageSizeOptions]="[5, 10]"
      showFirstLastButtons
    ></mat-paginator>
  </div>

  <!-- add new plant model -->
  <div
    class="sidepanel-model-wrapper edit-plant-row-model"
    [ngClass]="{ active: isaddNewPlantModeItemModelVisible }"
  >
    <div class="sidepanel-close" (click)="closeaddNewPlantItemModel()"></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">{{ formMode ? "Add" : "Update" }} {{langObj ? langObj?.Group : ('Group' | translate)}}</h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closeaddNewPlantItemModel()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
      <div class="model-body">
        <ngx-spinner
          bdColor="rgba(0, 0, 0, 0.8)"
          template=" <img src='assets/images/spinner.gif' />"
        ></ngx-spinner>

        <form
          [formGroup]="addNewPlantModeItemlForm"
          (ngSubmit)="
            formMode
              ? addNewPlantModeItemlFormSubmit()
              : editPlantModeItemlFormSubmit()
          "
        >
          <div class="form-group">
            <mat-form-field
              [ngClass]="{
                'is-invalid':
                  addNewPlantModeItemlForm.get('groupDescription')?.errors &&
                  addNewPlantModeItemlForm.get('groupDescription')?.touched
              }"
              appearance="fill"
              class="field-fill"
            >
              <mat-label>{{langObj ? langObj?.GroupDescription : ('GroupDescription' | translate)}}</mat-label>
              <input
                matInput
                placeholder="Group Description"
                formControlName="groupDescription"
              />
            </mat-form-field>
            <p
              class="invalid-feedback"
              *ngIf="
                addNewPlantModeItemlForm.get('groupDescription')?.touched &&
                addNewPlantModeItemlForm
                  .get('groupDescription')
                  ?.hasError('required')
              "
            >
              * group description is required!
            </p>
          </div>
          <div class="form-group">
            <mat-form-field
              [ngClass]="{
                'is-invalid':
                  addNewPlantModeItemlForm.get('groupOrder')?.errors &&
                  addNewPlantModeItemlForm.get('groupOrder')?.touched
              }"
              appearance="fill"
              class="field-fill"
            >
              <mat-label>{{langObj ? langObj?.GroupOrder : ('GroupOrder' | translate)}}</mat-label>
              <input
                matInput
                placeholder="Group Order"
                formControlName="groupOrder"
              />
            </mat-form-field>
            <p
              class="invalid-feedback"
              *ngIf="
                addNewPlantModeItemlForm.get('groupOrder')?.touched &&
                addNewPlantModeItemlForm.get('groupOrder')?.hasError('required')
              "
            >
              * group order is required!
            </p>
          </div>
          <div class="form-group">
            <mat-form-field
              [ngClass]="{
                'is-invalid':
                  addNewPlantModeItemlForm.get('noOfLic')?.errors &&
                  addNewPlantModeItemlForm.get('noOfLic')?.touched
              }"
              appearance="fill"
              class="field-fill"
            >
              <mat-label>{{langObj ? langObj?.NoOfLicense : ('NoOfLicense' | translate)}}</mat-label>
              <input
                matInput
                placeholder="No Of License"
                formControlName="noOfLic"
              />
            </mat-form-field>
            <p
              class="invalid-feedback"
              *ngIf="
                addNewPlantModeItemlForm.get('noOfLic')?.touched &&
                addNewPlantModeItemlForm.get('noOfLic')?.hasError('required')
              "
            >
              * No of License is required!
            </p>
          </div>
          <div class="form-group">
            <mat-checkbox color="accent" formControlName="active">
              {{langObj ? langObj?.Active : ('Active' | translate)}}
            </mat-checkbox>
          </div>
          <div class="form-group">
            <mat-form-field
              [ngClass]="{
                'is-invalid':
                  addNewPlantModeItemlForm.get('remarks')?.errors &&
                  addNewPlantModeItemlForm.get('remarks')?.touched
              }"
              appearance="fill"
              class="field-fill"
            >
              <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</mat-label>
              <textarea matInput formControlName="remarks"></textarea>
            </mat-form-field>
            <p
              class="invalid-feedback"
              *ngIf="
                addNewPlantModeItemlForm.get('remarks')?.touched &&
                addNewPlantModeItemlForm.get('remarks')?.hasError('required')
              "
            >
              * group remarks is required!
            </p>
          </div>
          <div class="model-form-actions">
            <button
              type="submit"
              class="add-btn"
              style="margin-left: 10px; margin-top: 0px"
              pTooltip="Update"
              tooltipPosition="top"
              *ngIf="!formMode"
            >
              <img
                src="assets/images/edit.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>
            <button
              type="submit"
              class="add-btn"
              style="margin-left: 10px; margin-top: 0px"
              pTooltip="Add"
              tooltipPosition="top"
              *ngIf="formMode"
              [disabled]="!addNewPlantModeItemlForm.valid"
            >
              <img
                src="assets/images/save.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>
            <button
              type="button"
              class="add-btn"
              style="margin-left: 10px; margin-top: 0px"
              pTooltip="Cancel"
              tooltipPosition="top"
              (click)="closeaddNewPlantItemModel()"
            >
              <img
                src="assets/images/cancel.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>
            <!-- <button type="button" mat-flat-button class="btn-cancel" (click)="closeaddNewPlantItemModel()"> Cancel
          </button>
          <button mat-flat-button color="accent" [disabled]="!addNewPlantModeItemlForm.valid" class="btn-accent">  {{formMode ? 'Add' : 'Update'}} </button> -->
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- plant group view model -->
  <div
    class="sidepanel-model-wrapper open-plant-group-model"
    [ngClass]="{ active: isPlantGroupModelVisible }"
  >
    <div class="sidepanel-close" (click)="closePlantGroupModel()"></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">{{langObj ? langObj?.GroupStructure : ('GroupStructure' | translate)}}</h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closePlantGroupModel()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
      <div class="model-body">
        <div class="tree-controls">
          <button
            mat-flat-button
            class="btn-tree-control"
            (click)="collapseAllNode()"
          >
            <div class="icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                  fill="#824AED"
                />
                <g clip-path="url(#clip0)">
                  <path
                    d="M14.0118 14.9844C13.933 14.897 13.8218 14.8399 13.6947 14.8395L10.1018 14.8345C9.86386 14.8341 9.67135 15.0265 9.67177 15.2645C9.67218 15.5024 9.94967 15.7699 10.0688 15.889L10.9776 16.7978L8.33301 19.417L9.58301 20.667L12.1888 18.0095L13.0976 18.9182C13.2942 19.1149 13.4938 19.3241 13.7317 19.3244C13.9697 19.3249 14.1622 19.1324 14.1617 18.8945L14.1568 15.3015C14.1563 15.1745 14.0993 15.0632 14.0118 14.9844ZM19.0763 11.1565L21.6663 8.58362L20.4163 7.33362L17.8442 9.91654L16.9201 8.98654C16.7201 8.78527 16.5172 8.57111 16.2755 8.5707C16.0334 8.57028 15.838 8.76737 15.838 9.0107L15.843 12.6882C15.843 12.8182 15.9013 12.9319 15.9905 13.0128C16.0709 13.1024 16.1838 13.1607 16.313 13.1611L19.9672 13.1661C20.2088 13.1665 20.4047 12.9694 20.4047 12.7261C20.4043 12.4828 20.1222 12.2086 20.0009 12.0869L19.0763 11.1565Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="13.3333"
                      height="13.3333"
                      fill="white"
                      transform="translate(8.33301 7.33362)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="btn-text">{{langObj ? langObj?.CollapseAll : ('CollapseAll' | translate)}}</p>
          </button>
          <!-- <button
            mat-flat-button
            class="btn-tree-control"
            (click)="expandAllNode()"
          >
            <div class="icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                  fill="#3AAFE4"
                />
                <g clip-path="url(#clip0)">
                  <path
                    d="M17.0932 8.50018L18.2178 9.62477L15.5086 12.3336C15.3561 12.4861 15.356 12.7333 15.5086 12.886L16.6138 13.9911C16.7666 14.1439 17.0143 14.1433 17.1665 13.9911L19.875 11.2819L20.9996 12.4065C21.2446 12.6515 21.6664 12.4783 21.6664 12.1303V8.22404C21.6664 8.00812 21.4916 7.83341 21.2757 7.83341H17.3695C17.0231 7.83341 16.8472 8.25336 17.0932 8.50018Z"
                    fill="white"
                  />
                  <path
                    d="M12.8332 15.0093L10.1244 17.7185L8.9998 16.5939C8.7548 16.3489 8.33301 16.522 8.33301 16.8701V20.7763C8.33301 20.9922 8.50772 21.1669 8.72363 21.1669H12.6299C12.9754 21.1669 13.1531 20.748 12.9061 20.5001L11.7819 19.3752L14.4907 16.6667C14.6432 16.5142 14.6433 16.267 14.4907 16.1144L13.3856 15.0093C13.2337 14.8574 12.9863 14.8562 12.8332 15.0093Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="13.3333"
                      height="13.3333"
                      fill="white"
                      transform="translate(8.33301 21.1669) rotate(-90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="btn-text">{{langObj ? langObj?.ExpandAll : ('ExpandAll' | translate)}}</p>
          </button> -->
        </div>

        <mat-tree
          #treeSelector
          class="basic-tree-structure"
          [dataSource]="plantGroupSource"
          [treeControl]="treeControl"
        >
          <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node
            *matTreeNodeDef="let node"
            class="child-node"
            matTreeNodePadding
          >
            <li class="tree-node">
              <!-- use a disabled button to provide padding for tree leaf -->
              <div class="tree-content">
                <button
                  mat-icon-button
                  disabled
                  class="child-space-elem"
                ></button>
                <div class="node-icon">
                  <div [ngSwitch]="node.Level">
                    <div *ngSwitchCase="'Group'">
                      <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M10.0101 9.89258H9.24838V11.6056H8V20.1187H11.2585V11.6056H10.0101V9.89258ZM10.2166 18.2144H9.04188V17.4526H10.2166V18.2144H10.2166ZM10.2166 16.6909H9.04188V15.9292H10.2166V16.6909H10.2166ZM10.2166 15.1675H9.04188V14.4058H10.2166V15.1675H10.2166ZM10.2166 12.8823V13.644H9.04188V12.8823H10.2166Z"
                          fill="white"
                        />
                        <path
                          d="M19.7516 11.6056V9.89258H18.9899V11.6056H17.7415V20.1187H21V11.6056H19.7516ZM19.9581 18.2144H18.7834V17.4526H19.9581V18.2144ZM19.9581 16.6909H18.7834V15.9292H19.9581V16.6909ZM19.9581 15.1675H18.7834V14.4058H19.9581V15.1675ZM19.9581 13.644H18.7834V12.8823H19.9581V13.644Z"
                          fill="white"
                        />
                        <path
                          d="M14.1191 18.9761H14.8809V20.1187H14.1191V18.9761Z"
                          fill="white"
                        />
                        <path
                          d="M12.0202 20.1188H13.3574V18.2145H15.6426V20.1188H16.9798V8.88037L12.0202 10.0472V20.1188ZM14.8809 11.359H16.0556V12.1207H14.8809V11.359ZM14.8809 12.8824H16.0556V13.6442H14.8809V12.8824ZM14.8809 14.4059H16.0556V15.1676H14.8809V14.4059ZM14.8809 15.9293H16.0556V16.691H14.8809V15.9293ZM12.9444 11.359H14.1191V12.1207H12.9444V11.359ZM12.9444 12.8824H14.1191V13.6442H12.9444V12.8824ZM12.9444 14.4059H14.1191V15.1676H12.9444V14.4059ZM12.9444 15.9293H14.1191V16.691H12.9444V15.9293Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Plant'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M19.4292 12.9508C19.238 12.8484 19.0091 12.8595 18.8282 12.9803L15.667 15.09V13.4707C15.667 13.2534 15.5453 13.0537 15.3539 12.9514C15.1624 12.849 14.9293 12.8603 14.748 12.9809L11.4975 15.1473V10.6091C11.4975 10.4885 11.4051 10.3816 11.2848 10.3816H7.48063C7.36037 10.3816 7.26251 10.4885 7.26251 10.6091V19.7836C7.26251 19.9039 7.36037 20.0003 7.48063 20.0003H19.5248C19.645 20.0003 19.7378 19.9039 19.7378 19.7836V13.4698C19.7381 13.2529 19.6212 13.0532 19.4292 12.9508ZM14.2882 17.2865C14.2882 17.3713 14.2196 17.4399 14.1342 17.4399H13.0635C12.9784 17.4399 12.9098 17.3713 12.9098 17.2865V16.2149C12.9098 16.1298 12.9784 16.0612 13.0635 16.0612H14.1342C14.2196 16.0612 14.2882 16.1298 14.2882 16.2149V17.2865ZM18.2929 17.2865C18.2929 17.3713 18.2249 17.4399 18.1395 17.4399H17.0685C16.9834 17.4399 16.9147 17.3713 16.9147 17.2865V16.2149C16.9147 16.1298 16.9834 16.0612 17.0685 16.0612H18.1395C18.2249 16.0612 18.2929 16.1298 18.2929 16.2149V17.2865Z"
                          fill="white"
                        />
                        <path
                          d="M7.48135 9.52779H11.2855C11.4058 9.52779 11.4982 9.44496 11.4982 9.3247V7.5877C11.4982 7.26237 11.2398 7 10.9142 7H7.85263C7.5273 7 7.26351 7.26237 7.26351 7.5877V9.32498C7.26351 9.44496 7.36137 9.52779 7.48135 9.52779Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Division'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M12.1428 9.63622H12.5934V10.0868H12.1428V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 11.4387H12.5934V11.8893H12.1428V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 13.2408H12.5934V13.6914H12.1428V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 15.0433H10.34V15.4939H9.88936V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 11.8893H18.0002V12.34H17.5496V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 13.2408H10.34V13.6914H9.88936V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 9.63622H10.34V10.0868H9.88936V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 15.0433H12.5934V15.4939H12.1428V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 11.4387H10.34V11.8893H9.88936V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 13.6917H16.1979V14.1423H15.7473V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 13.6917H18.0002V14.1423H17.5496V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 15.4939H18.0002V15.9445H17.5496V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 11.8893H16.1979V12.34H15.7473V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 15.4939H16.1979V15.9445H15.7473V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M9.66408 17.2964H11.0159V19.0988H9.66408V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M11.4664 17.2964H12.8183V19.0988H11.4664V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M16.1984 17.7474H17.5502V19.0992H16.1984V17.7474Z"
                            fill="white"
                          />
                          <path
                            d="M18.9018 19.5494V11.1638L14.8464 10.15V19.5494H14.3958V8.68251L8.08727 7V19.5494H7.41136V20H19.5777V19.5494H18.9018ZM11.6921 9.41079C11.6921 9.28637 11.793 9.18549 11.9174 9.18549H12.8186C12.9431 9.18549 13.0439 9.28637 13.0439 9.41079V10.312C13.0439 10.4364 12.9431 10.5373 12.8186 10.5373H11.9174C11.793 10.5373 11.6921 10.4364 11.6921 10.312V9.41079ZM11.6921 11.2132C11.6921 11.0888 11.793 10.9879 11.9174 10.9879H12.8186C12.9431 10.9879 13.0439 11.0888 13.0439 11.2132V12.1144C13.0439 12.2389 12.9431 12.3397 12.8186 12.3397H11.9174C11.793 12.3397 11.6921 12.2389 11.6921 12.1144V11.2132ZM11.6921 13.0156C11.6921 12.8912 11.793 12.7903 11.9174 12.7903H12.8186C12.9431 12.7903 13.0439 12.8912 13.0439 13.0156V13.9169C13.0439 14.0413 12.9431 14.1422 12.8186 14.1422H11.9174C11.793 14.1422 11.6921 14.0413 11.6921 13.9169V13.0156ZM11.6921 14.8181C11.6921 14.6936 11.793 14.5928 11.9174 14.5928H12.8186C12.9431 14.5928 13.0439 14.6936 13.0439 14.8181V15.7193C13.0439 15.8437 12.9431 15.9446 12.8186 15.9446H11.9174C11.793 15.9446 11.6921 15.8437 11.6921 15.7193V14.8181ZM9.43909 9.41079C9.43909 9.28637 9.53997 9.18549 9.66439 9.18549H10.5656C10.69 9.18549 10.7909 9.28637 10.7909 9.41079V10.312C10.7909 10.4364 10.69 10.5373 10.5656 10.5373H9.66439C9.53997 10.5373 9.43909 10.4364 9.43909 10.312V9.41079ZM9.43909 11.2132C9.43909 11.0888 9.53997 10.9879 9.66439 10.9879H10.5656C10.69 10.9879 10.7909 11.0888 10.7909 11.2132V12.1144C10.7909 12.2389 10.69 12.3397 10.5656 12.3397H9.66439C9.53997 12.3397 9.43909 12.2389 9.43909 12.1144V11.2132ZM9.43909 13.0156C9.43909 12.8912 9.53997 12.7903 9.66439 12.7903H10.5656C10.69 12.7903 10.7909 12.8912 10.7909 13.0156V13.9169C10.7909 14.0413 10.69 14.1422 10.5656 14.1422H9.66439C9.53997 14.1422 9.43909 14.0413 9.43909 13.9169V13.0156ZM9.43909 14.8181C9.43909 14.6936 9.53997 14.5928 9.66439 14.5928H10.5656C10.69 14.5928 10.7909 14.6936 10.7909 14.8181V15.7193C10.7909 15.8437 10.69 15.9446 10.5656 15.9446H9.66439C9.53997 15.9446 9.43909 15.8437 9.43909 15.7193V14.8181ZM13.2692 19.0988V19.5494H9.21379V17.0711C9.21379 16.9467 9.31467 16.8458 9.43909 16.8458H13.0439C13.1684 16.8458 13.2692 16.9467 13.2692 17.0711V19.0988ZM15.297 11.6638C15.297 11.5394 15.3979 11.4385 15.5223 11.4385H16.4235C16.5479 11.4385 16.6488 11.5394 16.6488 11.6638V12.565C16.6488 12.6895 16.5479 12.7903 16.4235 12.7903H15.5223C15.3979 12.7903 15.297 12.6895 15.297 12.565V11.6638ZM15.297 13.4662C15.297 13.3418 15.3979 13.2409 15.5223 13.2409H16.4235C16.5479 13.2409 16.6488 13.3418 16.6488 13.4662V14.3675C16.6488 14.4919 16.5479 14.5928 16.4235 14.5928H15.5223C15.3979 14.5928 15.297 14.4919 15.297 14.3675V13.4662ZM15.297 16.1699V15.2687C15.297 15.1443 15.3979 15.0434 15.5223 15.0434H16.4235C16.5479 15.0434 16.6488 15.1443 16.6488 15.2687V16.1699C16.6488 16.2943 16.5479 16.3952 16.4235 16.3952H15.5223C15.3979 16.3952 15.297 16.2943 15.297 16.1699ZM18.0006 19.5494H15.7476V17.5217C15.7476 17.3973 15.8485 17.2964 15.9729 17.2964H17.7753C17.8997 17.2964 18.0006 17.3973 18.0006 17.5217V19.5494ZM18.4512 16.1699C18.4512 16.2943 18.3503 16.3952 18.2259 16.3952H17.3247C17.2003 16.3952 17.0994 16.2943 17.0994 16.1699V15.2687C17.0994 15.1443 17.2003 15.0434 17.3247 15.0434H18.2259C18.3503 15.0434 18.4512 15.1443 18.4512 15.2687V16.1699ZM18.4512 14.3675C18.4512 14.4919 18.3503 14.5928 18.2259 14.5928H17.3247C17.2003 14.5928 17.0994 14.4919 17.0994 14.3675V13.4662C17.0994 13.3418 17.2003 13.2409 17.3247 13.2409H18.2259C18.3503 13.2409 18.4512 13.3418 18.4512 13.4662V14.3675ZM18.4512 12.565C18.4512 12.6895 18.3503 12.7903 18.2259 12.7903H17.3247C17.2003 12.7903 17.0994 12.6895 17.0994 12.565V11.6638C17.0994 11.5394 17.2003 11.4385 17.3247 11.4385H18.2259C18.3503 11.4385 18.4512 11.5394 18.4512 11.6638V12.565Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Department'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M14.7465 15.7852H12.2533C11.8885 15.7852 11.5918 16.0813 11.5918 16.4453V20H15.408V16.4453C15.408 16.0813 15.1113 15.7852 14.7465 15.7852Z"
                          fill="white"
                        />
                        <path
                          d="M18.5805 16.9531H16.8408C16.4728 16.9531 16.1735 17.2493 16.1735 17.6133C16.1735 19.73 16.1746 19.6035 16.1714 19.6336V20H19.2478V17.6133C19.2478 17.2493 18.9483 16.9531 18.5805 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M20 10.0723V8.39648C20 7.62643 19.3736 7 18.6037 7H8.39629C7.62643 7 7 7.62643 7 8.39648V10.0723H20ZM18.0697 8.54883C18.2801 8.54883 18.4506 8.71932 18.4506 8.92969C18.4506 9.14005 18.2801 9.31055 18.0697 9.31055C17.8595 9.31055 17.689 9.14005 17.689 8.92969C17.689 8.71932 17.8595 8.54883 18.0697 8.54883ZM16.5465 8.54883C16.7567 8.54883 16.9272 8.71932 16.9272 8.92969C16.9272 9.14005 16.7567 9.31055 16.5465 9.31055C16.3361 9.31055 16.1656 9.14005 16.1656 8.92969C16.1656 8.71932 16.3361 8.54883 16.5465 8.54883ZM15.0232 8.54883C15.2335 8.54883 15.404 8.71932 15.404 8.92969C15.404 9.14005 15.2335 9.31055 15.0232 9.31055C14.813 9.31055 14.6424 9.14005 14.6424 8.92969C14.6424 8.71932 14.813 8.54883 15.0232 8.54883Z"
                          fill="white"
                        />
                        <path
                          d="M9.30206 14.668C9.0916 14.668 8.92041 14.8389 8.92041 15.0488C8.92041 15.2588 9.0916 15.4297 9.30206 15.4297C9.51243 15.4297 9.68362 15.2588 9.68362 15.0488C9.68362 14.8389 9.51243 14.668 9.30206 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M10.16 16.9531H8.41859C8.05003 16.9531 7.7502 17.2493 7.7502 17.6133V20H10.8284C10.8284 19.3434 10.8284 17.7141 10.8284 17.6133C10.8284 17.2493 10.5286 16.9531 10.16 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M17.7235 14.668C17.513 14.668 17.3418 14.8389 17.3418 15.0488C17.3418 15.2588 17.513 15.4297 17.7235 15.4297C17.9339 15.4297 18.1051 15.2588 18.1051 15.0488C18.1051 14.8389 17.9339 14.668 17.7235 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M7 10.834V17.4261C7.09254 16.7303 7.69338 16.1914 8.4188 16.1914H9.30212C8.67082 16.1914 8.15726 15.6788 8.15726 15.0488C8.15726 14.4188 8.67082 13.9062 9.30212 13.9062C9.93341 13.9062 10.447 14.4188 10.447 15.0488C10.447 15.6788 9.93341 16.1914 9.30212 16.1914C10.1967 16.1914 10.4401 16.1505 10.8316 16.3579C10.877 15.6145 11.4972 15.0234 12.2534 15.0234H13.5127C12.7763 15.0234 12.177 14.4255 12.177 13.6904C12.177 12.9554 12.7763 12.3574 13.5127 12.3574C14.2492 12.3574 14.8484 12.9554 14.8484 13.6904C14.8484 14.4255 14.2492 15.0234 13.5127 15.0234H14.7466C15.5031 15.0234 16.1234 15.6149 16.1685 16.3587C16.5548 16.1533 16.7837 16.1914 17.7233 16.1914C17.092 16.1914 16.5784 15.6788 16.5784 15.0488C16.5784 14.4188 17.092 13.9062 17.7233 13.9062C18.3546 13.9062 18.8681 14.4188 18.8681 15.0488C18.8681 15.6788 18.3546 16.1914 17.7233 16.1914H18.5804C19.3104 16.1914 19.914 16.7378 20 17.4407V10.834H7Z"
                          fill="white"
                        />
                        <path
                          d="M13.5127 13.1191C13.1971 13.1191 12.9403 13.3754 12.9403 13.6904C12.9403 14.0054 13.1971 14.2617 13.5127 14.2617C13.8284 14.2617 14.0852 14.0054 14.0852 13.6904C14.0852 13.3754 13.8284 13.1191 13.5127 13.1191Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Line'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M16.0955 8.92341H15.5502C15.498 8.81308 15.4372 8.70761 15.3682 8.60752L15.6406 8.13559C15.7302 7.9804 15.6771 7.78197 15.5219 7.69239L14.398 7.04354C14.3235 7.0005 14.2349 6.98887 14.1518 7.01111C14.0687 7.0334 13.9979 7.08777 13.9548 7.16229L13.6828 7.63346C13.56 7.62303 13.44 7.62303 13.3172 7.63346L13.0452 7.16229C13.0021 7.08777 12.9313 7.0334 12.8482 7.01111C12.7651 6.98887 12.6765 7.0005 12.602 7.04354L11.4781 7.69242C11.3229 7.782 11.2698 7.98042 11.3594 8.13561L11.6318 8.60757C11.5628 8.70764 11.502 8.81314 11.4498 8.92343H10.9045C10.7253 8.92343 10.5801 9.06869 10.5801 9.24787V10.5456C10.5801 10.7248 10.7253 10.8701 10.9045 10.8701H11.4498C11.502 10.9803 11.5628 11.0858 11.6318 11.1859L11.3594 11.6579C11.2698 11.813 11.3229 12.0115 11.4781 12.101L12.602 12.7499C12.6765 12.793 12.765 12.8046 12.8482 12.7824C12.9313 12.7601 13.0021 12.7057 13.0452 12.6312L13.3172 12.1599C13.44 12.1704 13.56 12.1704 13.6828 12.1599L13.9548 12.6311C13.9979 12.7056 14.0687 12.76 14.1518 12.7823C14.1795 12.7897 14.2077 12.7933 14.2358 12.7933C14.2923 12.7933 14.3483 12.7786 14.398 12.7499L15.5219 12.101C15.6771 12.0114 15.7303 11.813 15.6407 11.6578L15.3682 11.1859C15.4373 11.0858 15.498 10.9803 15.5502 10.87H16.0955C16.2747 10.87 16.4199 10.7247 16.4199 10.5456V10.2211V9.57224V9.24785C16.4199 9.06867 16.2747 8.92341 16.0955 8.92341ZM13.5 10.8489C12.9749 10.8489 12.5479 10.4218 12.5479 9.89671C12.5479 9.37165 12.9749 8.94456 13.5 8.94456C14.0251 8.94456 14.4521 9.37165 14.4521 9.89671C14.4521 10.4218 14.0251 10.8489 13.5 10.8489Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 11.1108V10.2774H9.81836V9.5157H8.65039C8.44005 9.5157 8.26953 9.68622 8.26953 9.89655V11.1108C7.97426 11.1802 7.70322 11.33 7.48339 11.5499C7.17167 11.8616 7 12.276 7 12.7169C7 13.1577 7.17167 13.5722 7.48339 13.8839C7.6321 14.0326 7.87326 14.0326 8.022 13.8839C8.17074 13.7352 8.17074 13.494 8.022 13.3453C7.67552 12.9988 7.67552 12.435 8.022 12.0885C8.18986 11.9206 8.41301 11.8282 8.65039 11.8282C8.88777 11.8282 9.11093 11.9206 9.27878 12.0885C9.62526 12.435 9.62526 12.9988 9.27878 13.3453C9.13004 13.494 9.13004 13.7351 9.27878 13.8839C9.35315 13.9582 9.45063 13.9954 9.54808 13.9954C9.64553 13.9954 9.74303 13.9582 9.81737 13.8839C10.1291 13.5722 10.3008 13.1577 10.3008 12.7169C10.3008 12.276 10.1291 11.8616 9.81737 11.5499C9.59756 11.33 9.32652 11.1802 9.03125 11.1108Z"
                          fill="white"
                        />
                        <path
                          d="M19.5166 11.5498C19.2968 11.33 19.0257 11.1802 18.7305 11.1107V9.89649C18.7305 9.68615 18.5599 9.51563 18.3496 9.51563H17.1816V10.2773H17.9687V11.1107C17.6735 11.1802 17.4024 11.33 17.1826 11.5498C16.8709 11.8615 16.6992 12.276 16.6992 12.7168C16.6992 13.1577 16.8709 13.5721 17.1826 13.8838C17.3313 14.0325 17.5725 14.0325 17.7212 13.8838C17.87 13.7351 17.87 13.494 17.7212 13.3452C17.3747 12.9987 17.3747 12.4349 17.7212 12.0884C17.8891 11.9206 18.1122 11.8282 18.3496 11.8282C18.587 11.8282 18.8101 11.9206 18.978 12.0884C19.3245 12.4349 19.3245 12.9987 18.978 13.3452C18.8293 13.4939 18.8293 13.7351 18.978 13.8838C19.0524 13.9582 19.1498 13.9954 19.2473 13.9954C19.3447 13.9954 19.4422 13.9582 19.5166 13.8838C19.8283 13.5721 20 13.1577 20 12.7168C20 12.276 19.8283 11.8615 19.5166 11.5498Z"
                          fill="white"
                        />
                        <path
                          d="M8.04102 20C8.60193 20 9.05664 19.5453 9.05664 18.9844C9.05664 18.4235 8.60193 17.9688 8.04102 17.9688C7.4801 17.9688 7.02539 18.4235 7.02539 18.9844C7.02539 19.5453 7.4801 20 8.04102 20Z"
                          fill="white"
                        />
                        <path
                          d="M13.5 20C14.0609 20 14.5156 19.5453 14.5156 18.9844C14.5156 18.4235 14.0609 17.9688 13.5 17.9688C12.9391 17.9688 12.4844 18.4235 12.4844 18.9844C12.4844 19.5453 12.9391 20 13.5 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.9568 17.9688C15.1582 18.2569 15.2768 18.6069 15.2768 18.9844C15.2768 19.3618 15.1582 19.7119 14.9568 20H17.5012C17.2998 19.7119 17.1811 19.3618 17.1811 18.9844C17.1811 18.6069 17.2998 18.2569 17.5012 17.9688H14.9568Z"
                          fill="white"
                        />
                        <path
                          d="M9.49783 17.9688C9.69923 18.2569 9.81786 18.6069 9.81786 18.9844C9.81786 19.3618 9.69923 19.7119 9.49783 20H12.0422C11.8408 19.7119 11.7221 19.3618 11.7221 18.9844C11.7221 18.6069 11.8408 18.2569 12.0422 17.9688H9.49783Z"
                          fill="white"
                        />
                        <path
                          d="M18.959 20C19.5199 20 19.9746 19.5453 19.9746 18.9844C19.9746 18.4235 19.5199 17.9688 18.959 17.9688C18.3981 17.9688 17.9434 18.4235 17.9434 18.9844C17.9434 19.5453 18.3981 20 18.959 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.4521 14.9219H12.5479C12.3375 14.9219 12.167 15.0924 12.167 15.3027V17.207H14.833V15.3027C14.833 15.0924 14.6625 14.9219 14.4521 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M10.6436 14.9219H8.73926C8.52892 14.9219 8.3584 15.0924 8.3584 15.3027V17.207H11.0244V15.3027C11.0244 15.0924 10.8539 14.9219 10.6436 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M16.3564 14.9219C16.1461 14.9219 15.9756 15.0924 15.9756 15.3027V17.207H18.6416V15.3027C18.6416 15.0924 18.4711 14.9219 18.2607 14.9219H16.3564Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Unit'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M7.81226 16.3438H9.43726V15.9375H9.03101V13.2908C9.15703 13.1975 9.25942 13.0759 9.32998 12.9359C9.40054 12.7958 9.43729 12.6412 9.43729 12.4844C9.43729 12.3276 9.40054 12.1729 9.32998 12.0329C9.25942 11.8928 9.15703 11.7713 9.03101 11.678V9.90469L10.1055 11.0016C10.1242 11.0209 10.1466 11.0363 10.1714 11.0468C10.1962 11.0572 10.2229 11.0626 10.2498 11.0625H10.8591C10.913 11.0625 10.9647 11.0411 11.0028 11.003C11.0409 10.9649 11.0623 10.9132 11.0623 10.8594V10.25C11.0624 10.2231 11.057 10.1964 11.0465 10.1717C11.0361 10.1469 11.0207 10.1245 11.0013 10.1058L9.42304 8.56C9.43089 8.51433 9.43564 8.46818 9.43726 8.42188C9.43726 8.15251 9.33025 7.89419 9.13979 7.70372C8.94932 7.51325 8.69099 7.40625 8.42163 7.40625C8.15227 7.40625 7.89394 7.51325 7.70348 7.70372C7.51301 7.89419 7.40601 8.15251 7.40601 8.42188C7.40619 8.57865 7.44303 8.73321 7.51356 8.87322C7.5841 9.01324 7.68638 9.13482 7.81226 9.22828V11.678C7.68624 11.7713 7.58384 11.8928 7.51328 12.0329C7.44273 12.1729 7.40598 12.3276 7.40598 12.4844C7.40598 12.6412 7.44273 12.7958 7.51328 12.9359C7.58384 13.0759 7.68624 13.1975 7.81226 13.2908V16.3438Z"
                          fill="white"
                        />
                        <path
                          d="M13.2969 9.41922V10.25H13.7031V9.41922C13.9868 9.37102 14.2443 9.22411 14.4302 9.00444C14.616 8.78477 14.7182 8.50649 14.7188 8.21875V7.60938C14.7188 7.5555 14.6973 7.50384 14.6593 7.46574C14.6212 7.42765 14.5695 7.40625 14.5156 7.40625H12.4844C12.4305 7.40625 12.3788 7.42765 12.3407 7.46574C12.3027 7.50384 12.2812 7.5555 12.2812 7.60938V8.21875C12.2818 8.50649 12.384 8.78477 12.5698 9.00444C12.7557 9.22411 13.0132 9.37102 13.2969 9.41922Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 11.6455L14.7391 11.9015C14.3728 12.1477 13.9414 12.2793 13.5 12.2793C13.0586 12.2793 12.6272 12.1477 12.2609 11.9015L11.875 11.6455V14.1094H15.125V11.6455ZM13.7031 13.2969H13.2969V12.8907H13.7031V13.2969Z"
                          fill="white"
                        />
                        <path
                          d="M9.84375 16.3438H17.1562V15.125H9.84375V16.3438ZM15.7344 15.5312H16.1406V15.9375H15.7344V15.5312ZM14.9219 15.5312H15.3281V15.9375H14.9219V15.5312ZM14.1094 15.5312H14.5156V15.9375H14.1094V15.5312ZM13.2969 15.5312H13.7031V15.9375H13.2969V15.5312ZM12.4844 15.5312H12.8906V15.9375H12.4844V15.5312ZM11.6719 15.5312H12.0781V15.9375H11.6719V15.5312ZM10.8594 15.5312H11.2656V15.9375H10.8594V15.5312Z"
                          fill="white"
                        />
                        <path
                          d="M19.1874 11.678V9.22828C19.3133 9.13482 19.4156 9.01324 19.4861 8.87322C19.5567 8.73321 19.5935 8.57865 19.5937 8.42188C19.5937 8.15251 19.4867 7.89419 19.2962 7.70372C19.1057 7.51325 18.8474 7.40625 18.5781 7.40625C18.3087 7.40625 18.0504 7.51325 17.8599 7.70372C17.6694 7.89419 17.5624 8.15251 17.5624 8.42188C17.564 8.46818 17.5688 8.51433 17.5767 8.56L15.9984 10.1058C15.979 10.1245 15.9636 10.1469 15.9532 10.1717C15.9427 10.1964 15.9373 10.2231 15.9374 10.25V10.8594C15.9374 10.9132 15.9588 10.9649 15.9969 11.003C16.035 11.0411 16.0867 11.0625 16.1406 11.0625H16.7499C16.7768 11.0626 16.8035 11.0572 16.8283 11.0468C16.8531 11.0363 16.8755 11.0209 16.8942 11.0016L17.9687 9.90469V11.678C17.8427 11.7713 17.7403 11.8928 17.6697 12.0329C17.5992 12.1729 17.5624 12.3276 17.5624 12.4844C17.5624 12.6412 17.5992 12.7958 17.6697 12.9359C17.7403 13.0759 17.8427 13.1975 17.9687 13.2908V15.9375H17.5624V16.3438H19.1874V13.2908C19.3134 13.1975 19.4158 13.0759 19.4864 12.9359C19.557 12.7958 19.5937 12.6412 19.5937 12.4844C19.5937 12.3276 19.557 12.1729 19.4864 12.0329C19.4158 11.8928 19.3134 11.7713 19.1874 11.678Z"
                          fill="white"
                        />
                        <path
                          d="M7.8125 19.5938H19.1875V16.75H7.8125V19.5938ZM9.03125 17.3594H17.9688C18.1842 17.3594 18.3909 17.445 18.5433 17.5974C18.6956 17.7497 18.7812 17.9564 18.7812 18.1719C18.7812 18.3874 18.6956 18.594 18.5433 18.7464C18.3909 18.8988 18.1842 18.9844 17.9688 18.9844H9.03125C8.81576 18.9844 8.6091 18.8988 8.45673 18.7464C8.30435 18.594 8.21875 18.3874 8.21875 18.1719C8.21875 17.9564 8.30435 17.7497 8.45673 17.5974C8.6091 17.445 8.81576 17.3594 9.03125 17.3594Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 18.5781H17.9688C18.0765 18.5781 18.1798 18.5353 18.256 18.4591C18.3322 18.383 18.375 18.2796 18.375 18.1719C18.375 18.0641 18.3322 17.9608 18.256 17.8846C18.1798 17.8084 18.0765 17.7656 17.9688 17.7656H9.03125C8.92351 17.7656 8.82017 17.8084 8.74399 17.8846C8.6678 17.9608 8.625 18.0641 8.625 18.1719C8.625 18.2796 8.6678 18.383 8.74399 18.4591C8.82017 18.5353 8.92351 18.5781 9.03125 18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.109 10.6562H12.8902C12.8364 10.6562 12.7847 10.6777 12.7466 10.7157C12.7085 10.7538 12.6871 10.8055 12.6871 10.8594V11.4688H12.3418L12.486 11.5642C12.786 11.7649 13.1387 11.872 13.4996 11.872C13.8605 11.872 14.2132 11.7649 14.5132 11.5642L14.6574 11.4688H14.3121V10.8594C14.3121 10.8055 14.2907 10.7538 14.2526 10.7157C14.2145 10.6777 14.1629 10.6562 14.109 10.6562ZM13.9059 11.4688H13.0934V11.0625H13.9059V11.4688Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Assembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M18.9731 16.9459V16.5576C19.3349 16.4076 19.5902 16.0508 19.5902 15.6353C19.5902 15.085 19.1425 14.6372 18.5922 14.6372C18.1777 14.6372 17.8216 14.8912 17.671 15.2517H16.4327C16.4219 14.9873 16.557 14.7343 16.7905 14.5982C17.1925 14.3639 17.2712 13.8161 16.9515 13.478C16.7415 13.2559 16.6941 12.9257 16.833 12.6534C17.0445 12.2389 16.8146 11.7355 16.3628 11.624C16.066 11.5507 15.8476 11.2986 15.8173 10.9944C15.7712 10.5313 15.3056 10.2321 14.8652 10.3825C14.5759 10.4813 14.2559 10.3873 14.0659 10.1478C13.7767 9.78325 13.2233 9.78325 12.9342 10.1478C12.7442 10.3873 12.4241 10.4813 12.1349 10.3825C11.701 10.2343 11.243 10.5227 11.1854 10.9739H9.33118C9.23021 10.7283 9.03403 10.5315 8.78865 10.4298V9.99877C9.30301 9.8129 9.67167 9.31977 9.67167 8.74213C9.67167 8.00551 9.07241 7.40625 8.33588 7.40625C7.59926 7.40625 7 8.00551 7 8.74203C7 9.37234 7.43888 9.90167 8.02693 10.0414V10.4297C7.66512 10.5797 7.40982 10.9365 7.40982 11.352C7.40982 11.9023 7.85753 12.3501 8.40779 12.3501C8.82227 12.3501 9.17844 12.0961 9.32899 11.7356H10.3927C10.1107 11.9353 9.99818 12.3226 10.167 12.6534C10.3059 12.9256 10.2585 13.2558 10.0485 13.478C9.7287 13.816 9.80755 14.3639 10.2095 14.5981C10.4737 14.7521 10.6122 15.0556 10.5556 15.3559C10.4694 15.8132 10.8318 16.2315 11.2968 16.2112C11.6021 16.198 11.8827 16.3784 11.9975 16.6616C12.1722 17.093 12.7033 17.2489 13.0834 16.9805C13.3332 16.8043 13.6668 16.8043 13.9165 16.9805C14.2967 17.2489 14.8277 17.093 15.0024 16.6616C15.1172 16.3784 15.3979 16.198 15.7032 16.2112C15.9098 16.2203 16.096 16.1425 16.2318 16.0134H17.6688C17.7698 16.259 17.966 16.4558 18.2113 16.5575V16.9885C17.697 17.1744 17.3283 17.6675 17.3283 18.2452C17.3283 18.9818 17.9276 19.5811 18.6641 19.5811C19.4007 19.5811 20 18.9818 20 18.2453C20 17.615 19.5611 17.0856 18.9731 16.9459ZM7.76172 8.74203C7.76172 8.42545 8.01929 8.16787 8.33588 8.16787C8.65237 8.16787 8.91005 8.42545 8.91005 8.74203C8.91005 9.05862 8.65247 9.3162 8.33588 9.3162C8.01929 9.3162 7.76172 9.05862 7.76172 8.74203ZM11.291 13.4937C11.291 12.2756 12.2819 11.2847 13.5 11.2847C14.7181 11.2847 15.709 12.2756 15.709 13.4937C15.709 14.7117 14.7181 15.7026 13.5 15.7026C12.2819 15.7026 11.291 14.7117 11.291 13.4937ZM18.6641 18.8194C18.3475 18.8194 18.09 18.5619 18.09 18.2453C18.09 17.9287 18.3476 17.6711 18.6641 17.6711C18.9807 17.6711 19.2383 17.9287 19.2383 18.2453C19.2383 18.5619 18.9807 18.8194 18.6641 18.8194Z"
                            fill="white"
                          />
                          <path
                            d="M13.5 14.9409C14.298 14.9409 14.9473 14.2917 14.9473 13.4937C14.9473 12.6956 14.298 12.0464 13.5 12.0464C12.702 12.0464 12.0527 12.6956 12.0527 13.4937C12.0527 14.2917 12.702 14.9409 13.5 14.9409Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'SubAssembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M17.9688 11.4688H17.5625V11.0625C17.5625 10.838 17.3807 10.6563 17.1562 10.6563H16.75V9.03125H16.9531C17.0652 9.03125 17.1562 8.94025 17.1562 8.82813V8.42188C17.1562 8.30975 17.0652 8.21875 16.9531 8.21875H14.4557C14.4943 8.34753 14.5156 8.48383 14.5156 8.625C14.5156 8.76617 14.4943 8.90247 14.4557 9.03125H15.9375V10.6563H15.5312C15.3068 10.6563 15.125 10.838 15.125 11.0625V11.4688H14.7188C13.8213 11.4688 13.0938 12.1963 13.0938 13.0938V13.5C13.0938 14.3285 13.7143 15.0108 14.5156 15.111V14.3125C14.5156 14.303 14.5181 14.294 14.5185 14.2847C14.1671 14.1951 13.9062 13.8792 13.9062 13.5V13.0938C13.9062 12.645 14.27 12.2813 14.7188 12.2813H15.9375V12.6875C15.9375 12.912 16.1193 13.0938 16.3438 13.0938C16.5682 13.0938 16.75 12.912 16.75 12.6875V12.2813H17.9688C18.4175 12.2813 18.7812 12.645 18.7812 13.0938V13.5C18.7812 13.8792 18.5204 14.1951 18.169 14.2847C18.1694 14.294 18.1719 14.303 18.1719 14.3125V15.111C18.9732 15.0108 19.5938 14.3285 19.5938 13.5V13.0938C19.5938 12.1963 18.8662 11.4688 17.9688 11.4688Z"
                          fill="white"
                        />
                        <path
                          d="M16.9531 14.9219V14.1094H15.7344V14.9219H16.1406V14.5156H16.5469V14.9219H16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M18.5781 17.7656V16.9531H17.5625H17.3594V17.7656H17.7656V17.3594H18.1719V17.7656H18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 17.7656H14.5156V17.3594H14.9219V17.7656H15.3281V16.9531H15.125H14.1094V17.7656Z"
                          fill="white"
                        />
                        <path
                          d="M19.1875 16.9531H18.9844V18.1719H16.9531V16.9531H16.75C16.6379 16.9531 16.5469 17.0443 16.5469 17.1562V19.1875C16.5469 19.2994 16.6379 19.3906 16.75 19.3906H19.1875C19.2996 19.3906 19.3906 19.2994 19.3906 19.1875V17.1562C19.3906 17.0443 19.2996 16.9531 19.1875 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.9375 16.9531H15.7344V18.1719H13.7031V16.9531H13.5C13.3879 16.9531 13.2969 17.0443 13.2969 17.1562V19.1875C13.2969 19.2994 13.3879 19.3906 13.5 19.3906H15.9375C16.0496 19.3906 16.1406 19.2994 16.1406 19.1875V17.1562C16.1406 17.0443 16.0496 16.9531 15.9375 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 14.1094C15.0129 14.1094 14.9219 14.2006 14.9219 14.3125V16.3438C14.9219 16.4557 15.0129 16.5469 15.125 16.5469H15.9375H16.75H17.5625C17.6746 16.5469 17.7656 16.4557 17.7656 16.3438V14.3125C17.7656 14.2006 17.6746 14.1094 17.5625 14.1094H17.3594V15.3281H15.3281V14.1094H15.125Z"
                          fill="white"
                        />
                        <path
                          d="M10.4531 12.2812C10.4531 11.5004 9.82039 10.8653 9.041 10.8598L9.03389 10.8596V10.8594C9.03287 10.8596 9.03206 10.8594 9.03125 10.8594C8.24739 10.8594 7.60938 11.4972 7.60938 12.2812C7.60938 13.0653 8.24739 13.7031 9.03125 13.7031C9.81511 13.7031 10.4531 13.0653 10.4531 12.2812ZM8.21875 12.2812C8.21875 11.8325 8.58255 11.4688 9.03125 11.4688C9.47995 11.4688 9.84375 11.8325 9.84375 12.2812C9.84375 12.73 9.47995 13.0938 9.03125 13.0938C8.58255 13.0938 8.21875 12.73 8.21875 12.2812Z"
                          fill="white"
                        />
                        <path
                          d="M11.7395 9.05685L9.58984 10.5407C10.1005 10.705 10.5139 11.0877 10.7188 11.5787L12.3156 9.81309C12.0458 9.63596 11.8397 9.37007 11.7395 9.05685Z"
                          fill="white"
                        />
                        <path
                          d="M8.44687 14.0122L9.1962 17.0977L11.0944 17.3824L10.0942 13.7658C9.7942 13.9811 9.42776 14.1095 9.03106 14.1095C8.82671 14.1095 8.6307 14.0744 8.44687 14.0122Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 8.625C14.1094 8.06498 13.6538 7.60938 13.0938 7.60938C12.5337 7.60938 12.0781 8.06498 12.0781 8.625C12.0781 9.18502 12.5337 9.64062 13.0938 9.64062C13.6538 9.64062 14.1094 9.18502 14.1094 8.625ZM12.6875 8.625C12.6875 8.40055 12.8693 8.21875 13.0938 8.21875C13.3182 8.21875 13.5 8.40055 13.5 8.625C13.5 8.84945 13.3182 9.03125 13.0938 9.03125C12.8693 9.03125 12.6875 8.84945 12.6875 8.625Z"
                          fill="white"
                        />
                        <path
                          d="M11.5591 17.8626L11.236 17.8141L11.2157 17.8198L11.2132 17.8106L8.42188 17.392V19.3905H12.0781V18.4653C12.0781 18.1612 11.86 17.9077 11.5591 17.8626Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Component'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M19.7396 12.7307L18.6543 12.3689C18.6198 12.2116 18.5781 12.0556 18.5294 11.9022L19.2883 11.0464C19.3971 10.9237 19.4152 10.7452 19.3332 10.6033L18.9253 9.89674C18.8433 9.75478 18.6798 9.6812 18.5191 9.71403L17.3962 9.94376C17.2882 9.82552 17.1746 9.71187 17.0563 9.60368L17.286 8.48096C17.3189 8.32034 17.2453 8.15672 17.1033 8.07476L16.3967 7.66681C16.2548 7.58485 16.0763 7.60287 15.9536 7.7117L15.0978 8.4706C14.9445 8.42193 14.7886 8.38016 14.6311 8.34565L14.2693 7.26041C14.2174 7.10489 14.0718 7 13.9079 7H13.092C12.9281 7 12.7826 7.10489 12.7308 7.26038L12.3689 8.34563C12.2115 8.38016 12.0555 8.4219 11.9022 8.47057L11.0464 7.7117C10.9237 7.6029 10.7452 7.58487 10.6033 7.66681L9.89671 8.07476C9.75473 8.15672 9.68115 8.32034 9.71403 8.48096L9.94376 9.60368C9.82542 9.71185 9.7118 9.82549 9.60378 9.94376L8.48093 9.71403C8.32029 9.68117 8.1567 9.75478 8.07476 9.89674L7.66683 10.6033C7.58485 10.7452 7.60293 10.9238 7.71172 11.0464L8.47062 11.9022C8.4219 12.0556 8.38018 12.2116 8.34575 12.3689L7.26043 12.7307C7.10489 12.7826 7 12.9281 7 13.092V13.908C7 14.0719 7.10491 14.2174 7.26046 14.2693L8.3457 14.6309C8.38013 14.7883 8.42188 14.9443 8.4706 15.0978L7.7117 15.9536C7.60293 16.0763 7.58485 16.2548 7.66681 16.3967L8.07473 17.1033C8.15672 17.2452 8.32024 17.3188 8.48091 17.286L9.60376 17.0562C9.71182 17.1745 9.82542 17.2882 9.94374 17.3962L9.714 18.519C9.68115 18.6796 9.75473 18.8433 9.89669 18.9252L10.6033 19.3331C10.7453 19.4151 10.9237 19.397 11.0464 19.2882L11.9022 18.5294C12.0556 18.578 12.2115 18.6198 12.3689 18.6542L12.7307 19.7395C12.7826 19.8951 12.9281 19.9999 13.092 19.9999H13.9079C14.0718 19.9999 14.2174 19.8951 14.2692 19.7395L14.631 18.6542C14.7884 18.6198 14.9443 18.578 15.0978 18.5294L15.9535 19.2882C16.0762 19.397 16.2547 19.4151 16.3967 19.3331L17.1032 18.9252C17.2452 18.8433 17.3188 18.6796 17.2859 18.519L17.0562 17.3962C17.1745 17.2882 17.2881 17.1745 17.3962 17.0562L18.519 17.286C18.6797 17.3189 18.8433 17.2452 18.9252 17.1033L19.3331 16.3967C19.4151 16.2548 19.397 16.0762 19.2882 15.9536L18.5293 15.0978C18.578 14.9443 18.6198 14.7883 18.6542 14.6309L19.7395 14.2693C19.895 14.2174 19.9999 14.0719 19.9999 13.908V13.092C20 12.9281 19.8951 12.7826 19.7396 12.7307ZM14.9822 10.1705L13.9494 11.9597C13.6515 11.8728 13.3397 11.8765 13.0509 11.9607L12.0182 10.1722C12.9383 9.76392 14.0156 9.73934 14.9822 10.1705ZM14.343 13.5C14.343 13.9648 13.9648 14.343 13.5 14.343C13.0352 14.343 12.657 13.9648 12.657 13.5C12.657 13.0352 13.0352 12.657 13.5 12.657C13.9648 12.657 14.343 13.0352 14.343 13.5ZM11.3587 10.553L12.3914 12.3415C12.1741 12.5496 12.0151 12.8177 11.9414 13.1192H9.87546C9.98528 12.0664 10.5452 11.1457 11.3587 10.553ZM11.3587 16.447C10.5452 15.8543 9.9853 14.9336 9.87546 13.8809H11.9414C12.0151 14.1823 12.1741 14.4505 12.3914 14.6585L11.3587 16.447ZM12.0178 16.8295L13.0506 15.0403C13.3485 15.1272 13.6603 15.1235 13.9491 15.0393L14.9818 16.8278C14.0617 17.2361 12.9844 17.2607 12.0178 16.8295ZM15.6413 16.447L14.6086 14.6585C14.8259 14.4504 14.9849 14.1823 15.0586 13.8809H17.1245C17.0147 14.9336 16.4548 15.8543 15.6413 16.447ZM15.0587 13.1191C14.985 12.8177 14.8259 12.5495 14.6087 12.3415L15.6413 10.5529C16.4548 11.1457 17.0147 12.0664 17.1246 13.1191H15.0587V13.1191Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <p class="tree-text-main"></p>
                <p class="tree-text">
                  {{ replaceIcon(node.icon) }}{{ node.text }}
                </p>
                <div class="node-controls" *ngIf="IsWrite">
                  <button
                    mat-icon-button
                    class="node-control-btn node-edit"
                    aria-label="Edit item"
                    (click)="openEditGroupModel(node)"
                  >
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.5 7.62527V9.50027H2.375L7.905 3.97027L6.03 2.09527L0.5 7.62527ZM9.355 2.52027C9.55 2.32527 9.55 2.01027 9.355 1.81527L8.185 0.645273C7.99 0.450273 7.675 0.450273 7.48 0.645273L6.565 1.56027L8.44 3.43527L9.355 2.52027Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button
                    mat-icon-button
                    class="node-control-btn node-delete"
                    aria-label="delete item"
                    (click)="deleteGroupNode(node)"
                  >
                    <svg
                      width="8"
                      height="10"
                      viewBox="0 0 8 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.35547 0.9375H5.60547L5.10547 0.4375H2.60547L2.10547 0.9375H0.355469V1.9375H7.35547V0.9375ZM0.855469 8.4375C0.855469 8.70272 0.960826 8.95707 1.14836 9.14461C1.3359 9.33214 1.59025 9.4375 1.85547 9.4375H5.85547C6.12069 9.4375 6.37504 9.33214 6.56258 9.14461C6.75011 8.95707 6.85547 8.70272 6.85547 8.4375V2.4375H0.855469V8.4375Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-nested-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            class="parent-node"
            matTreeNodePadding
          >
            <li class="tree-node">
              <div class="tree-content">
                <button
                  mat-icon-button
                  class="tree-tpggler"
                  [attr.aria-label]="'Toggle ' + node.text"
                  matTreeNodeToggle
                  [ngClass]="{ 'node-open': treeControl.isExpanded(node) }"
                  (click)="treeExpandCollapse(node)"
                >
                  <span *ngIf="!treeControl.isExpanded(node)">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="#7B868C"
                      />
                      <path
                        d="M11.25 8.0353H8.03571H6.96429H3.75V6.96387H6.96429H8.03571H11.25V8.0353Z"
                        fill="#7B868C"
                      />
                      <path
                        d="M6.96429 11.25L6.96429 8.03571L6.96429 6.96429L6.96429 3.75L8.03572 3.75L8.03572 6.96429L8.03572 8.03571L8.03572 11.25L6.96429 11.25Z"
                        fill="#7B868C"
                      />
                    </svg>
                  </span>
                  <span *ngIf="treeControl.isExpanded(node)">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="#7B868C"
                      />
                      <path
                        d="M11.25 8.2853H8.03571H6.96429H3.75V7.21387H6.96429H8.03571H11.25V8.2853Z"
                        fill="#7B868C"
                      />
                    </svg>
                  </span>
                </button>
                <div
                  class="node-icon"
                  [ngStyle]="{
                    'background-color':
                      replaceString(node.icon) === true ? 'red' : ''
                  }"
                  [ngClass]="{ 'node-open': treeControl.isExpanded(node) }"
                >
                  <div [ngSwitch]="node.Level">
                    <div *ngSwitchCase="'Group'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.0101 1.89258H1.24838V3.60556H0V12.1187H3.25845V3.60556H2.0101V1.89258ZM2.21658 10.2144H1.04188V9.45264H2.2166V10.2144H2.21658ZM2.21658 8.69092H1.04188V7.9292H2.2166V8.69092H2.21658ZM2.21658 7.16748H1.04188V6.40576H2.2166V7.16748H2.21658ZM2.21658 4.88232V5.64404H1.04188V4.88232H2.21658Z"
                          fill="white"
                        />
                        <path
                          d="M11.7513 3.60556V1.89258H10.9896V3.60556H9.74121V12.1187H12.9997V3.60556H11.7513ZM11.9578 10.2144H10.7831V9.45264H11.9578V10.2144ZM11.9578 8.69092H10.7831V7.9292H11.9578V8.69092ZM11.9578 7.16748H10.7831V6.40576H11.9578V7.16748ZM11.9578 5.64404H10.7831V4.88232H11.9578V5.64404Z"
                          fill="white"
                        />
                        <path
                          d="M6.11914 10.9766H6.88086V12.1191H6.11914V10.9766Z"
                          fill="white"
                        />
                        <path
                          d="M4.02051 12.1193H5.35776V10.215H7.64292V12.1193H8.98018V0.880859L4.02051 2.04766V12.1193ZM6.8812 3.35947H8.05593V4.12119H6.8812V3.35947ZM6.8812 4.88293H8.05593V5.64465H6.8812V4.88293ZM6.8812 6.40637H8.05593V7.16809H6.8812V6.40637ZM6.8812 7.9298H8.05593V8.69152H6.8812V7.9298ZM4.94475 3.35947H6.11948V4.12119H4.94475V3.35947ZM4.94475 4.88293H6.11948V5.64465H4.94475V4.88293ZM4.94475 6.40637H6.11948V7.16809H4.94475V6.40637ZM4.94475 7.9298H6.11948V8.69152H4.94475V7.9298Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Plant'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.4294 5.95006C12.2382 5.84766 12.0093 5.85872 11.8283 5.97955L8.66719 8.08926V6.46996C8.66719 6.2527 8.5455 6.05302 8.35405 5.95062C8.16259 5.84823 7.92944 5.85958 7.7482 5.98012L4.4977 8.14655V3.60834C4.4977 3.48779 4.40523 3.38086 4.28497 3.38086H0.480813C0.360551 3.38086 0.262695 3.48779 0.262695 3.60834V12.7829C0.262695 12.9032 0.360551 12.9996 0.480813 12.9996H12.525C12.6452 12.9996 12.738 12.9032 12.738 12.7829V6.46911C12.7382 6.25213 12.6214 6.05245 12.4294 5.95006ZM7.28842 10.2858C7.28842 10.3706 7.21978 10.4392 7.1344 10.4392H6.06367C5.97858 10.4392 5.90994 10.3706 5.90994 10.2858V9.21417C5.90994 9.12907 5.97858 9.06043 6.06367 9.06043H7.1344C7.21978 9.06043 7.28842 9.12907 7.28842 9.21417V10.2858ZM11.2931 10.2858C11.2931 10.3706 11.225 10.4392 11.1397 10.4392H10.0686C9.98355 10.4392 9.91491 10.3706 9.91491 10.2858V9.21417C9.91491 9.12907 9.98355 9.06043 10.0686 9.06043H11.1397C11.225 9.06043 11.2931 9.12907 11.2931 9.21417V10.2858Z"
                          fill="white"
                        />
                        <path
                          d="M0.481506 2.52779H4.28567C4.40593 2.52779 4.49839 2.44496 4.49839 2.3247V0.587699C4.49839 0.262366 4.24 0 3.91438 0H0.852789C0.527456 0 0.263672 0.262366 0.263672 0.587699V2.32498C0.263672 2.44496 0.361527 2.52779 0.481506 2.52779Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Division'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9016 12.5494V4.16382L7.84614 3.14996V12.5494H7.39553V1.68251L1.08704 0V12.5494H0.411133V13H12.5775V12.5494H11.9016ZM4.6919 2.41079C4.6919 2.28637 4.79278 2.18549 4.9172 2.18549H5.81841C5.94283 2.18549 6.04372 2.28637 6.04372 2.41079V3.312C6.04372 3.43643 5.94283 3.53731 5.81841 3.53731H4.9172C4.79278 3.53731 4.6919 3.43643 4.6919 3.312V2.41079ZM4.6919 4.21322C4.6919 4.08879 4.79278 3.98791 4.9172 3.98791H5.81841C5.94283 3.98791 6.04372 4.08879 6.04372 4.21322V5.11443C6.04372 5.23885 5.94283 5.33973 5.81841 5.33973H4.9172C4.79278 5.33973 4.6919 5.23885 4.6919 5.11443V4.21322ZM4.6919 6.01564C4.6919 5.89122 4.79278 5.79034 4.9172 5.79034H5.81841C5.94283 5.79034 6.04372 5.89122 6.04372 6.01564V6.91686C6.04372 7.04128 5.94283 7.14216 5.81841 7.14216H4.9172C4.79278 7.14216 4.6919 7.04128 4.6919 6.91686V6.01564ZM4.6919 7.81807C4.6919 7.69365 4.79278 7.59277 4.9172 7.59277H5.81841C5.94283 7.59277 6.04372 7.69365 6.04372 7.81807V8.71928C6.04372 8.84371 5.94283 8.94458 5.81841 8.94458H4.9172C4.79278 8.94458 4.6919 8.84371 4.6919 8.71928V7.81807ZM2.43886 2.41079C2.43886 2.28637 2.53974 2.18549 2.66417 2.18549H3.56538C3.6898 2.18549 3.79068 2.28637 3.79068 2.41079V3.312C3.79068 3.43643 3.6898 3.53731 3.56538 3.53731H2.66417C2.53974 3.53731 2.43886 3.43643 2.43886 3.312V2.41079ZM2.43886 4.21322C2.43886 4.08879 2.53974 3.98791 2.66417 3.98791H3.56538C3.6898 3.98791 3.79068 4.08879 3.79068 4.21322V5.11443C3.79068 5.23885 3.6898 5.33973 3.56538 5.33973H2.66417C2.53974 5.33973 2.43886 5.23885 2.43886 5.11443V4.21322ZM2.43886 6.01564C2.43886 5.89122 2.53974 5.79034 2.66417 5.79034H3.56538C3.6898 5.79034 3.79068 5.89122 3.79068 6.01564V6.91686C3.79068 7.04128 3.6898 7.14216 3.56538 7.14216H2.66417C2.53974 7.14216 2.43886 7.04128 2.43886 6.91686V6.01564ZM2.43886 7.81807C2.43886 7.69365 2.53974 7.59277 2.66417 7.59277H3.56538C3.6898 7.59277 3.79068 7.69365 3.79068 7.81807V8.71928C3.79068 8.84371 3.6898 8.94458 3.56538 8.94458H2.66417C2.53974 8.94458 2.43886 8.84371 2.43886 8.71928V7.81807ZM6.26902 12.0988V12.5494H2.21356V10.0711C2.21356 9.94668 2.31444 9.8458 2.43886 9.8458H6.04372C6.16814 9.8458 6.26902 9.94668 6.26902 10.0711V12.0988ZM8.29675 4.66382C8.29675 4.5394 8.39763 4.43852 8.52205 4.43852H9.42326C9.54769 4.43852 9.64857 4.5394 9.64857 4.66382V5.56504C9.64857 5.68946 9.54769 5.79034 9.42326 5.79034H8.52205C8.39763 5.79034 8.29675 5.68946 8.29675 5.56504V4.66382ZM8.29675 6.46625C8.29675 6.34183 8.39763 6.24095 8.52205 6.24095H9.42326C9.54769 6.24095 9.64857 6.34183 9.64857 6.46625V7.36746C9.64857 7.49189 9.54769 7.59277 9.42326 7.59277H8.52205C8.39763 7.59277 8.29675 7.49189 8.29675 7.36746V6.46625ZM8.29675 9.16989V8.26868C8.29675 8.14425 8.39763 8.04337 8.52205 8.04337H9.42326C9.54769 8.04337 9.64857 8.14425 9.64857 8.26868V9.16989C9.64857 9.29431 9.54769 9.39519 9.42326 9.39519H8.52205C8.39763 9.39519 8.29675 9.29431 8.29675 9.16989ZM11.0004 12.5494H8.74735V10.5217C8.74735 10.3973 8.84824 10.2964 8.97266 10.2964H10.7751C10.8995 10.2964 11.0004 10.3973 11.0004 10.5217V12.5494ZM11.451 9.16989C11.451 9.29431 11.3501 9.39519 11.2257 9.39519H10.3245C10.2001 9.39519 10.0992 9.29431 10.0992 9.16989V8.26868C10.0992 8.14425 10.2001 8.04337 10.3245 8.04337H11.2257C11.3501 8.04337 11.451 8.14425 11.451 8.26868V9.16989ZM11.451 7.36746C11.451 7.49189 11.3501 7.59277 11.2257 7.59277H10.3245C10.2001 7.59277 10.0992 7.49189 10.0992 7.36746V6.46625C10.0992 6.34183 10.2001 6.24095 10.3245 6.24095H11.2257C11.3501 6.24095 11.451 6.34183 11.451 6.46625V7.36746ZM11.451 5.56504C11.451 5.68946 11.3501 5.79034 11.2257 5.79034H10.3245C10.2001 5.79034 10.0992 5.68946 10.0992 5.56504V4.66382C10.0992 4.5394 10.2001 4.43852 10.3245 4.43852H11.2257C11.3501 4.43852 11.451 4.5394 11.451 4.66382V5.56504Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Department'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.74648 8.78516H5.25324C4.88845 8.78516 4.5918 9.08131 4.5918 9.44531V13H8.40793V9.44531C8.40793 9.08131 8.11128 8.78516 7.74648 8.78516Z"
                          fill="white"
                        />
                        <path
                          d="M11.5809 9.95312H9.84126C9.47329 9.95312 9.17396 10.2493 9.17396 10.6133C9.17396 12.73 9.17505 12.6035 9.17188 12.6336V13H12.2482V10.6133C12.2482 10.2493 11.9488 9.95312 11.5809 9.95312Z"
                          fill="white"
                        />
                        <path
                          d="M13 3.07227V1.39648C13 0.626434 12.3736 0 11.6037 0H1.39629C0.626434 0 0 0.626434 0 1.39648V3.07227H13ZM11.0697 1.54883C11.2801 1.54883 11.4506 1.71932 11.4506 1.92969C11.4506 2.14005 11.2801 2.31055 11.0697 2.31055C10.8595 2.31055 10.689 2.14005 10.689 1.92969C10.689 1.71932 10.8595 1.54883 11.0697 1.54883ZM9.54648 1.54883C9.75674 1.54883 9.92724 1.71932 9.92724 1.92969C9.92724 2.14005 9.75674 2.31055 9.54648 2.31055C9.33611 2.31055 9.16562 2.14005 9.16562 1.92969C9.16562 1.71932 9.33611 1.54883 9.54648 1.54883ZM8.02324 1.54883C8.23351 1.54883 8.404 1.71932 8.404 1.92969C8.404 2.14005 8.23351 2.31055 8.02324 2.31055C7.81297 2.31055 7.64238 2.14005 7.64238 1.92969C7.64238 1.71932 7.81297 1.54883 8.02324 1.54883Z"
                          fill="white"
                        />
                        <path
                          d="M2.30157 7.66797C2.09111 7.66797 1.91992 7.83886 1.91992 8.04883C1.91992 8.2588 2.09111 8.42969 2.30157 8.42969C2.51194 8.42969 2.68313 8.2588 2.68313 8.04883C2.68313 7.83886 2.51194 7.66797 2.30157 7.66797Z"
                          fill="white"
                        />
                        <path
                          d="M3.15983 9.95312H1.41839C1.04983 9.95312 0.75 10.2493 0.75 10.6133V13H3.82822C3.82822 12.3434 3.82822 10.7141 3.82822 10.6133C3.82822 10.2493 3.52839 9.95312 3.15983 9.95312Z"
                          fill="white"
                        />
                        <path
                          d="M10.7234 7.66797C10.513 7.66797 10.3418 7.83886 10.3418 8.04883C10.3418 8.2588 10.513 8.42969 10.7234 8.42969C10.9339 8.42969 11.1051 8.2588 11.1051 8.04883C11.1051 7.83886 10.9339 7.66797 10.7234 7.66797Z"
                          fill="white"
                        />
                        <path
                          d="M0 3.83398V10.4261C0.0925369 9.73026 0.693382 9.19141 1.4188 9.19141H2.30212C1.67082 9.19141 1.15726 8.67883 1.15726 8.04883C1.15726 7.41882 1.67082 6.90625 2.30212 6.90625C2.93341 6.90625 3.44698 7.41882 3.44698 8.04883C3.44698 8.67883 2.93341 9.19141 2.30212 9.19141C3.19674 9.19141 3.44013 9.15054 3.8316 9.35793C3.87703 8.61446 4.49722 8.02344 5.25338 8.02344H6.5127C5.77627 8.02344 5.17701 7.42547 5.17701 6.69043C5.17701 5.95539 5.77627 5.35742 6.5127 5.35742C7.24922 5.35742 7.84838 5.95539 7.84838 6.69043C7.84838 7.42547 7.24922 8.02344 6.5127 8.02344H7.74662C8.50308 8.02344 9.12337 8.61486 9.1685 9.35873C9.55481 9.15332 9.78372 9.19141 10.7233 9.19141C10.092 9.19141 9.57841 8.67883 9.57841 8.04883C9.57841 7.41882 10.092 6.90625 10.7233 6.90625C11.3546 6.90625 11.8681 7.41882 11.8681 8.04883C11.8681 8.67883 11.3546 9.19141 10.7233 9.19141H11.5804C12.3104 9.19141 12.914 9.7378 13 10.4407V3.83398H0Z"
                          fill="white"
                        />
                        <path
                          d="M6.51281 6.11914C6.19721 6.11914 5.94043 6.37543 5.94043 6.69043C5.94043 7.00543 6.19721 7.26172 6.51281 7.26172C6.82851 7.26172 7.08529 7.00543 7.08529 6.69043C7.08529 6.37543 6.82851 6.11914 6.51281 6.11914Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Line'">
                      <svg
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.09548 1.92334H8.55022C8.49801 1.81302 8.43723 1.70754 8.36817 1.60745L8.64063 1.13552C8.73024 0.98033 8.67707 0.781902 8.52188 0.692324L7.39802 0.043467C7.32349 0.000429854 7.23491 -0.0111991 7.15183 0.0110431C7.06872 0.0333361 6.99786 0.0876974 6.95485 0.162219L6.68281 0.633393C6.56005 0.622957 6.43995 0.622957 6.31719 0.633393L6.04515 0.162219C6.00212 0.0876974 5.93125 0.0333361 5.84817 0.0110431C5.76509 -0.0111991 5.67651 0.000429854 5.60198 0.043467L4.47812 0.69235C4.32293 0.781928 4.26976 0.980356 4.35937 1.13554L4.63183 1.6075C4.56277 1.70757 4.50199 1.81307 4.44978 1.92336H3.90452C3.72534 1.92336 3.58008 2.06862 3.58008 2.2478V3.54554C3.58008 3.72473 3.72534 3.86999 3.90452 3.86999H4.44978C4.50199 3.98026 4.56277 4.08576 4.63183 4.18582L4.35937 4.65778C4.26976 4.81297 4.32293 5.0114 4.47812 5.10097L5.60198 5.74986C5.67648 5.79289 5.76504 5.8045 5.84817 5.78228C5.93128 5.75999 6.00214 5.70563 6.04515 5.63111L6.31719 5.15988C6.43995 5.17037 6.56005 5.17037 6.68281 5.15988L6.95485 5.63105C6.99788 5.70558 7.06875 5.75994 7.15183 5.78223C7.17945 5.78962 7.20769 5.79328 7.23582 5.79328C7.29229 5.79328 7.3483 5.77852 7.39804 5.74981L8.52191 5.10092C8.67709 5.01135 8.73026 4.81292 8.64066 4.65773L8.36819 4.18579C8.43725 4.08573 8.49804 3.98026 8.55024 3.86994H9.09551C9.27469 3.86994 9.41995 3.72468 9.41995 3.54549V3.22105V2.57217V2.24778C9.41992 2.0686 9.27466 1.92334 9.09548 1.92334ZM6.5 3.84878C5.97495 3.84878 5.54785 3.42169 5.54785 2.89664C5.54785 2.37158 5.97495 1.94449 6.5 1.94449C7.02505 1.94449 7.45215 2.37158 7.45215 2.89664C7.45215 3.42169 7.02505 3.84878 6.5 3.84878Z"
                          fill="white"
                        />
                        <path
                          d="M2.03125 4.11074V3.27734H2.81836V2.51562H1.65039C1.44005 2.51562 1.26953 2.68615 1.26953 2.89648V4.11074C0.974264 4.18016 0.703219 4.32996 0.483387 4.54982C0.171666 4.86152 0 5.27597 0 5.7168C0 6.15763 0.171666 6.57211 0.483387 6.8838C0.6321 7.03252 0.87326 7.03252 1.022 6.8838C1.17074 6.73509 1.17074 6.49393 1.022 6.34519C0.675518 5.99871 0.675518 5.43489 1.022 5.08841C1.18986 4.92057 1.41301 4.82813 1.65039 4.82813C1.88777 4.82813 2.11093 4.92057 2.27878 5.08841C2.62526 5.43489 2.62526 5.99871 2.27878 6.34519C2.13004 6.4939 2.13004 6.73506 2.27878 6.8838C2.35315 6.95817 2.45063 6.99537 2.54808 6.99537C2.64553 6.99537 2.74303 6.95817 2.81737 6.8838C3.12909 6.57211 3.30076 6.15763 3.30076 5.7168C3.30076 5.27597 3.12909 4.86149 2.81737 4.5498C2.59756 4.32996 2.32652 4.18016 2.03125 4.11074Z"
                          fill="white"
                        />
                        <path
                          d="M12.5166 4.54982C12.2968 4.32996 12.0257 4.18018 11.7305 4.11074V2.89648C11.7305 2.68615 11.5599 2.51562 11.3496 2.51562H10.1816V3.27734H10.9687V4.11074C10.6735 4.18016 10.4024 4.32996 10.1826 4.54982C9.87088 4.86154 9.69922 5.27599 9.69922 5.71682C9.69922 6.15766 9.87088 6.57213 10.1826 6.88383C10.3313 7.03254 10.5725 7.03254 10.7212 6.88383C10.87 6.73512 10.87 6.49395 10.7212 6.34522C10.3747 5.99874 10.3747 5.43491 10.7212 5.08843C10.8891 4.9206 11.1122 4.82815 11.3496 4.82815C11.587 4.82815 11.8101 4.9206 11.978 5.08843C12.3245 5.43491 12.3245 5.99874 11.978 6.34522C11.8293 6.49393 11.8293 6.73509 11.978 6.88383C12.0524 6.9582 12.1498 6.99539 12.2473 6.99539C12.3447 6.99539 12.4422 6.9582 12.5166 6.88383C12.8283 6.57213 13 6.15766 13 5.71682C13 5.27599 12.8283 4.86154 12.5166 4.54982Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Unit'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.812531 9.34375H2.43753V8.9375H2.03128V6.29078C2.1573 6.19746 2.2597 6.0759 2.33025 5.93586C2.40081 5.79582 2.43756 5.64119 2.43756 5.48438C2.43756 5.32756 2.40081 5.17293 2.33025 5.03289C2.2597 4.89285 2.1573 4.77129 2.03128 4.67797V2.90469L3.10581 4.00156C3.1245 4.02092 3.14691 4.0363 3.17169 4.04677C3.19648 4.05724 3.22312 4.06259 3.25003 4.0625H3.85941C3.91328 4.0625 3.96494 4.0411 4.00304 4.00301C4.04113 3.96491 4.06253 3.91325 4.06253 3.85938V3.25C4.06263 3.22309 4.05728 3.19645 4.0468 3.17166C4.03633 3.14688 4.02095 3.12447 4.00159 3.10578L2.42331 1.56C2.43116 1.51433 2.43592 1.46818 2.43753 1.42188C2.43753 1.15251 2.33053 0.894186 2.14006 0.70372C1.94959 0.513253 1.69127 0.40625 1.42191 0.40625C1.15255 0.40625 0.894217 0.513253 0.703751 0.70372C0.513284 0.894186 0.406281 1.15251 0.406281 1.42188C0.406469 1.57865 0.4433 1.73321 0.513835 1.87322C0.58437 2.01324 0.686657 2.13482 0.812531 2.22828V4.67797C0.68651 4.77129 0.584114 4.89285 0.513558 5.03289C0.443002 5.17293 0.40625 5.32756 0.40625 5.48438C0.40625 5.64119 0.443002 5.79582 0.513558 5.93586C0.584114 6.0759 0.68651 6.19746 0.812531 6.29078V9.34375Z"
                          fill="white"
                        />
                        <path
                          d="M6.29688 2.41922V3.25H6.70312V2.41922C6.9868 2.37102 7.24431 2.22411 7.43015 2.00444C7.616 1.78477 7.71822 1.50649 7.71875 1.21875V0.609375C7.71875 0.555503 7.69735 0.503837 7.65926 0.465744C7.62116 0.427651 7.5695 0.40625 7.51562 0.40625H5.48438C5.4305 0.40625 5.37884 0.427651 5.34074 0.465744C5.30265 0.503837 5.28125 0.555503 5.28125 0.609375V1.21875C5.28178 1.50649 5.384 1.78477 5.56985 2.00444C5.75569 2.22411 6.0132 2.37102 6.29688 2.41922Z"
                          fill="white"
                        />
                        <path
                          d="M8.125 4.64648L7.73906 4.90242C7.37276 5.14869 6.94139 5.28023 6.5 5.28023C6.05861 5.28023 5.62724 5.14869 5.26094 4.90242L4.875 4.64648V7.11041H8.125V4.64648ZM6.70312 6.2979H6.29688V5.89165H6.70312V6.2979Z"
                          fill="white"
                        />
                        <path
                          d="M2.84375 9.34375H10.1562V8.125H2.84375V9.34375ZM8.73438 8.53125H9.14062V8.9375H8.73438V8.53125ZM7.92188 8.53125H8.32812V8.9375H7.92188V8.53125ZM7.10938 8.53125H7.51562V8.9375H7.10938V8.53125ZM6.29688 8.53125H6.70312V8.9375H6.29688V8.53125ZM5.48438 8.53125H5.89062V8.9375H5.48438V8.53125ZM4.67188 8.53125H5.07812V8.9375H4.67188V8.53125ZM3.85938 8.53125H4.26562V8.9375H3.85938V8.53125Z"
                          fill="white"
                        />
                        <path
                          d="M12.1875 4.67797V2.22828C12.3134 2.13482 12.4156 2.01324 12.4862 1.87322C12.5567 1.73321 12.5935 1.57865 12.5937 1.42188C12.5937 1.15251 12.4867 0.894186 12.2963 0.70372C12.1058 0.513253 11.8475 0.40625 11.5781 0.40625C11.3088 0.40625 11.0504 0.513253 10.86 0.70372C10.6695 0.894186 10.5625 1.15251 10.5625 1.42188C10.5641 1.46818 10.5689 1.51433 10.5767 1.56L8.99844 3.10578C8.97908 3.12447 8.9637 3.14688 8.95323 3.17166C8.94276 3.19645 8.93741 3.22309 8.9375 3.25V3.85938C8.9375 3.91325 8.9589 3.96491 8.99699 4.00301C9.03509 4.0411 9.08675 4.0625 9.14063 4.0625H9.75C9.7769 4.06259 9.80355 4.05724 9.82834 4.04677C9.85312 4.0363 9.87553 4.02092 9.89422 4.00156L10.9687 2.90469V4.67797C10.8427 4.77129 10.7403 4.89285 10.6698 5.03289C10.5992 5.17293 10.5625 5.32756 10.5625 5.48438C10.5625 5.64119 10.5992 5.79582 10.6698 5.93586C10.7403 6.0759 10.8427 6.19746 10.9687 6.29078V8.9375H10.5625V9.34375H12.1875V6.29078C12.3135 6.19746 12.4159 6.0759 12.4865 5.93586C12.557 5.79582 12.5938 5.64119 12.5938 5.48438C12.5938 5.32756 12.557 5.17293 12.4865 5.03289C12.4159 4.89285 12.3135 4.77129 12.1875 4.67797Z"
                          fill="white"
                        />
                        <path
                          d="M0.8125 12.5938H12.1875V9.75H0.8125V12.5938ZM2.03125 10.3594H10.9688C11.1842 10.3594 11.3909 10.445 11.5433 10.5974C11.6956 10.7497 11.7812 10.9564 11.7812 11.1719C11.7812 11.3874 11.6956 11.594 11.5433 11.7464C11.3909 11.8988 11.1842 11.9844 10.9688 11.9844H2.03125C1.81576 11.9844 1.6091 11.8988 1.45673 11.7464C1.30435 11.594 1.21875 11.3874 1.21875 11.1719C1.21875 10.9564 1.30435 10.7497 1.45673 10.5974C1.6091 10.445 1.81576 10.3594 2.03125 10.3594Z"
                          fill="white"
                        />
                        <path
                          d="M2.03125 11.5781H10.9688C11.0765 11.5781 11.1798 11.5353 11.256 11.4591C11.3322 11.383 11.375 11.2796 11.375 11.1719C11.375 11.0641 11.3322 10.9608 11.256 10.8846C11.1798 10.8084 11.0765 10.7656 10.9688 10.7656H2.03125C1.92351 10.7656 1.82017 10.8084 1.74399 10.8846C1.6678 10.9608 1.625 11.0641 1.625 11.1719C1.625 11.2796 1.6678 11.383 1.74399 11.4591C1.82017 11.5353 1.92351 11.5781 2.03125 11.5781Z"
                          fill="white"
                        />
                        <path
                          d="M7.10898 3.65625H5.89023C5.83636 3.65625 5.7847 3.67765 5.7466 3.71574C5.70851 3.75384 5.68711 3.8055 5.68711 3.85938V4.46875H5.3418L5.48602 4.56422C5.78597 4.76486 6.13873 4.87197 6.49961 4.87197C6.86049 4.87197 7.21325 4.76486 7.5132 4.56422L7.65742 4.46875H7.31211V3.85938C7.31211 3.8055 7.29071 3.75384 7.25262 3.71574C7.21452 3.67765 7.16286 3.65625 7.10898 3.65625ZM6.90586 4.46875H6.09336V4.0625H6.90586V4.46875Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Assembly'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            d="M11.9731 9.94588V9.55759C12.3349 9.40762 12.5902 9.05077 12.5902 8.63529C12.5902 8.08503 12.1425 7.63722 11.5922 7.63722C11.1777 7.63722 10.8216 7.89123 10.671 8.25166H9.43272C9.42191 7.98734 9.55699 7.73432 9.79047 7.59824C10.1925 7.36388 10.2712 6.81609 9.95154 6.47798C9.74147 6.25591 9.69406 5.92574 9.83302 5.65338C10.0445 5.2389 9.81457 4.73555 9.36279 4.62397C9.06604 4.55067 8.84764 4.29855 8.81729 3.99436C8.77117 3.53128 8.30561 3.23215 7.86524 3.38251C7.57593 3.48129 7.25587 3.38727 7.06593 3.14784C6.77672 2.78325 6.22328 2.78325 5.93417 3.14784C5.74423 3.38727 5.42407 3.48129 5.13486 3.38251C4.70103 3.23433 4.24301 3.52265 4.18539 3.97393H2.33118C2.23021 3.72826 2.03403 3.53148 1.78865 3.42982V2.99877C2.30301 2.8129 2.67167 2.31977 2.67167 1.74213C2.67167 1.00551 2.07241 0.40625 1.33588 0.40625C0.599258 0.40625 0 1.00551 0 1.74203C0 2.37234 0.438881 2.90167 1.02693 3.04142V3.42972C0.665115 3.57968 0.409821 3.93654 0.409821 4.35201C0.409821 4.90228 0.857529 5.35008 1.40779 5.35008C1.82227 5.35008 2.17844 5.09608 2.32899 4.73565H3.39272C3.11075 4.9353 2.99818 5.32261 3.16698 5.65338C3.30594 5.92564 3.25853 6.25581 3.04846 6.47798C2.7287 6.81599 2.80755 7.36388 3.20953 7.59814C3.47366 7.75208 3.61221 8.05557 3.55558 8.3559C3.46939 8.81322 3.8318 9.23148 4.29677 9.21124C4.60215 9.19795 4.88274 9.37836 4.99749 9.66163C5.17225 10.093 5.70327 10.2489 6.08344 9.9805C6.33318 9.80425 6.66682 9.80425 6.91647 9.9805C7.29673 10.2489 7.82765 10.093 8.00241 9.66163C8.11716 9.37836 8.39785 9.19795 8.70323 9.21124C8.90983 9.22027 9.09599 9.14251 9.23177 9.01337H10.6688C10.7698 9.25905 10.966 9.45583 11.2113 9.55749V9.98853C10.697 10.1744 10.3283 10.6675 10.3283 11.2452C10.3283 11.9818 10.9276 12.5811 11.6641 12.5811C12.4007 12.5811 13 11.9818 13 11.2453C13 10.615 12.5611 10.0856 11.9731 9.94588ZM0.761719 1.74203C0.761719 1.42545 1.01929 1.16787 1.33588 1.16787C1.65237 1.16787 1.91005 1.42545 1.91005 1.74203C1.91005 2.05862 1.65247 2.3162 1.33588 2.3162C1.01929 2.3162 0.761719 2.05862 0.761719 1.74203ZM4.29102 6.49365C4.29102 5.2756 5.28194 4.28467 6.5 4.28467C7.71806 4.28467 8.70898 5.2756 8.70898 6.49365C8.70898 7.71171 7.71806 8.70264 6.5 8.70264C5.28194 8.70264 4.29102 7.71171 4.29102 6.49365ZM11.6641 11.8194C11.3475 11.8194 11.09 11.5619 11.09 11.2453C11.09 10.9287 11.3476 10.6711 11.6641 10.6711C11.9807 10.6711 12.2383 10.9287 12.2383 11.2453C12.2383 11.5619 11.9807 11.8194 11.6641 11.8194Z"
                            fill="white"
                          />
                          <path
                            d="M6.5 7.94141C7.29802 7.94141 7.94727 7.29216 7.94727 6.49414C7.94727 5.69612 7.29802 5.04688 6.5 5.04688C5.70198 5.04688 5.05273 5.69612 5.05273 6.49414C5.05273 7.29216 5.70198 7.94141 6.5 7.94141Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="13" height="13" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'SubAssembly'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.9688 4.46875H10.5625V4.0625C10.5625 3.83805 10.3807 3.65625 10.1562 3.65625H9.75V2.03125H9.95312C10.0652 2.03125 10.1562 1.94025 10.1562 1.82813V1.42188C10.1562 1.30975 10.0652 1.21875 9.95312 1.21875H7.4557C7.4943 1.34753 7.51562 1.48383 7.51562 1.625C7.51562 1.76617 7.4943 1.90247 7.4557 2.03125H8.9375V3.65625H8.53125C8.3068 3.65625 8.125 3.83805 8.125 4.0625V4.46875H7.71875C6.82134 4.46875 6.09375 5.19634 6.09375 6.09375V6.5C6.09375 7.32855 6.7143 8.01084 7.51562 8.11098V7.3125C7.51562 7.30295 7.51806 7.29402 7.51847 7.28467C7.16706 7.19509 6.90625 6.87923 6.90625 6.5V6.09375C6.90625 5.64505 7.27005 5.28125 7.71875 5.28125H8.9375V5.6875C8.9375 5.91195 9.1193 6.09375 9.34375 6.09375C9.5682 6.09375 9.75 5.91195 9.75 5.6875V5.28125H10.9688C11.4175 5.28125 11.7812 5.64505 11.7812 6.09375V6.5C11.7812 6.87923 11.5204 7.19509 11.169 7.28467C11.1694 7.29402 11.1719 7.30295 11.1719 7.3125V8.11098C11.9732 8.01084 12.5938 7.32855 12.5938 6.5V6.09375C12.5938 5.19634 11.8662 4.46875 10.9688 4.46875Z"
                          fill="white"
                        />
                        <path
                          d="M9.95312 7.92188V7.10938H8.73438V7.92188H9.14062V7.51562H9.54688V7.92188H9.95312Z"
                          fill="white"
                        />
                        <path
                          d="M11.5781 10.7656V9.95312H10.5625H10.3594V10.7656H10.7656V10.3594H11.1719V10.7656H11.5781Z"
                          fill="white"
                        />
                        <path
                          d="M7.10938 10.7656H7.51562V10.3594H7.92188V10.7656H8.32812V9.95312H8.125H7.10938V10.7656Z"
                          fill="white"
                        />
                        <path
                          d="M12.1875 9.95312H11.9844V11.1719H9.95312V9.95312H9.75C9.63788 9.95312 9.54688 10.0443 9.54688 10.1562V12.1875C9.54688 12.2994 9.63788 12.3906 9.75 12.3906H12.1875C12.2996 12.3906 12.3906 12.2994 12.3906 12.1875V10.1562C12.3906 10.0443 12.2996 9.95312 12.1875 9.95312Z"
                          fill="white"
                        />
                        <path
                          d="M8.9375 9.95312H8.73438V11.1719H6.70312V9.95312H6.5C6.38788 9.95312 6.29688 10.0443 6.29688 10.1562V12.1875C6.29688 12.2994 6.38788 12.3906 6.5 12.3906H8.9375C9.04962 12.3906 9.14062 12.2994 9.14062 12.1875V10.1562C9.14062 10.0443 9.04962 9.95312 8.9375 9.95312Z"
                          fill="white"
                        />
                        <path
                          d="M8.125 7.10938C8.01288 7.10938 7.92188 7.20058 7.92188 7.3125V9.34375C7.92188 9.45567 8.01288 9.54688 8.125 9.54688H8.9375H9.75H10.5625C10.6746 9.54688 10.7656 9.45567 10.7656 9.34375V7.3125C10.7656 7.20058 10.6746 7.10938 10.5625 7.10938H10.3594V8.32812H8.32812V7.10938H8.125Z"
                          fill="white"
                        />
                        <path
                          d="M3.45312 5.28125C3.45312 4.50044 2.82039 3.86527 2.041 3.85978L2.03389 3.85958V3.85938C2.03287 3.85958 2.03206 3.85938 2.03125 3.85938C1.24739 3.85938 0.609375 4.49719 0.609375 5.28125C0.609375 6.06531 1.24739 6.70312 2.03125 6.70312C2.81511 6.70312 3.45312 6.06531 3.45312 5.28125ZM1.21875 5.28125C1.21875 4.83255 1.58255 4.46875 2.03125 4.46875C2.47995 4.46875 2.84375 4.83255 2.84375 5.28125C2.84375 5.72995 2.47995 6.09375 2.03125 6.09375C1.58255 6.09375 1.21875 5.72995 1.21875 5.28125Z"
                          fill="white"
                        />
                        <path
                          d="M4.73952 2.05664L2.58984 3.54047C3.1005 3.7048 3.51386 4.08748 3.71881 4.57844L5.31558 2.81287C5.04583 2.63575 4.83966 2.36986 4.73952 2.05664Z"
                          fill="white"
                        />
                        <path
                          d="M1.44727 7.01202L2.19659 10.0975L4.0948 10.3823L3.09461 6.76562C2.79459 6.98094 2.42816 7.10931 2.03145 7.10931C1.82711 7.10931 1.63109 7.07417 1.44727 7.01202Z"
                          fill="white"
                        />
                        <path
                          d="M7.10938 1.625C7.10938 1.06498 6.65377 0.609375 6.09375 0.609375C5.53373 0.609375 5.07812 1.06498 5.07812 1.625C5.07812 2.18502 5.53373 2.64062 6.09375 2.64062C6.65377 2.64062 7.10938 2.18502 7.10938 1.625ZM5.6875 1.625C5.6875 1.40055 5.8693 1.21875 6.09375 1.21875C6.3182 1.21875 6.5 1.40055 6.5 1.625C6.5 1.84945 6.3182 2.03125 6.09375 2.03125C5.8693 2.03125 5.6875 1.84945 5.6875 1.625Z"
                          fill="white"
                        />
                        <path
                          d="M4.55914 10.8632L4.23597 10.8147L4.21566 10.8204L4.21322 10.8112L1.42188 10.3926V12.3911H5.07812V11.4659C5.07812 11.1618 4.85997 10.9083 4.55914 10.8632Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Component'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.7396 5.73074L11.6543 5.36892C11.6198 5.21158 11.5781 5.05563 11.5294 4.90219L12.2883 4.0464C12.3971 3.92374 12.4152 3.74524 12.3332 3.60329L11.9253 2.89674C11.8433 2.75478 11.6798 2.6812 11.5191 2.71403L10.3962 2.94376C10.2882 2.82552 10.1746 2.71187 10.0563 2.60368L10.286 1.48096C10.3189 1.32034 10.2453 1.15672 10.1033 1.07476L9.39674 0.666809C9.25483 0.584848 9.07631 0.602875 8.95362 0.711699L8.09783 1.4706C7.94452 1.42193 7.78857 1.38016 7.63113 1.34565L7.26926 0.260406C7.21739 0.104889 7.07185 0 6.90793 0H6.09205C5.92813 0 5.78259 0.104889 5.73077 0.260381L5.3689 1.34563C5.21145 1.38016 5.0555 1.4219 4.90219 1.47057L4.0464 0.711699C3.92371 0.6029 3.74522 0.584873 3.60329 0.666809L2.89671 1.07476C2.75473 1.15672 2.68115 1.32034 2.71403 1.48096L2.94376 2.60368C2.82542 2.71185 2.7118 2.82549 2.60378 2.94376L1.48093 2.71403C1.32029 2.68117 1.1567 2.75478 1.07476 2.89674L0.666834 3.60329C0.584848 3.74524 0.602926 3.92377 0.711725 4.0464L1.47062 4.90219C1.4219 5.05563 1.38018 5.21158 1.34575 5.36892L0.260432 5.73074C0.104889 5.78259 0 5.92813 0 6.09205V6.90795C0 7.0719 0.104914 7.21744 0.260457 7.26926L1.3457 7.6309C1.38013 7.78832 1.42188 7.94432 1.4706 8.09781L0.711699 8.9536C0.602926 9.07626 0.584848 9.25476 0.666809 9.39672L1.07473 10.1033C1.15672 10.2452 1.32024 10.3188 1.48091 10.286L2.60376 10.0562C2.71182 10.1745 2.82542 10.2882 2.94374 10.3962L2.714 11.519C2.68115 11.6796 2.75473 11.8433 2.89669 11.9252L3.60326 12.3331C3.74527 12.4151 3.92371 12.397 4.04638 12.2882L4.90217 11.5294C5.05558 11.578 5.21153 11.6198 5.3689 11.6542L5.73071 12.7395C5.78256 12.8951 5.9281 12.9999 6.09202 12.9999H6.9079C7.07182 12.9999 7.21736 12.8951 7.26921 12.7395L7.63103 11.6542C7.7884 11.6198 7.94435 11.578 8.09776 11.5294L8.95355 12.2882C9.07621 12.397 9.25471 12.4151 9.39666 12.3331L10.1032 11.9252C10.2452 11.8433 10.3188 11.6796 10.2859 11.519L10.0562 10.3962C10.1745 10.2882 10.2881 10.1745 10.3962 10.0562L11.519 10.286C11.6797 10.3189 11.8433 10.2452 11.9252 10.1033L12.3331 9.39672C12.4151 9.25476 12.397 9.07623 12.2882 8.9536L11.5293 8.09781C11.578 7.94432 11.6198 7.78832 11.6542 7.6309L12.7395 7.26926C12.895 7.21744 12.9999 7.0719 12.9999 6.90795V6.09205C13 5.92813 12.8951 5.78259 12.7396 5.73074ZM7.98223 3.17053L6.94939 4.9597C6.65146 4.87282 6.33973 4.87647 6.05094 4.96067L5.01823 3.17215C5.93828 2.76392 7.01561 2.73934 7.98223 3.17053ZM7.34297 6.5C7.34297 6.96483 6.9648 7.34297 6.5 7.34297C6.0352 7.34297 5.65703 6.9648 5.65703 6.5C5.65703 6.0352 6.0352 5.65703 6.5 5.65703C6.9648 5.65703 7.34297 6.03517 7.34297 6.5ZM4.35871 3.55296L5.39137 5.34153C5.17408 5.54955 5.01505 5.8177 4.94137 6.11917H2.87546C2.98528 5.06639 3.54519 4.14568 4.35871 3.55296ZM4.35871 9.44704C3.54519 8.85432 2.9853 7.93361 2.87546 6.88086H4.94137C5.01505 7.18232 5.1741 7.45047 5.39137 7.65847L4.35871 9.44704ZM5.01777 9.82947L6.05061 8.0403C6.34854 8.12721 6.66027 8.12353 6.94906 8.03933L7.98177 9.82785C7.06172 10.2361 5.98439 10.2607 5.01777 9.82947ZM8.64129 9.44704L7.60863 7.65847C7.8259 7.45045 7.98494 7.1823 8.05863 6.88086H10.1245C10.0147 7.93358 9.45481 8.85432 8.64129 9.44704ZM8.05865 6.11914C7.98497 5.81768 7.82592 5.54953 7.60866 5.3415L8.64132 3.55294C9.45483 4.14565 10.0147 5.06639 10.1246 6.11911H8.05865V6.11914Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <p
                  class="tree-text-main"
                  [ngStyle]="{
                    color: replaceString(node.icon) === true ? 'red' : ''
                  }"
                ></p>
                <p
                  class="tree-text"
                  [ngStyle]="{
                    color: replaceString(node.icon) === true ? 'red' : ''
                  }"
                >
                  {{ replaceIcon(node.icon) }}{{ node.text }}
                </p>
                <div class="node-controls" *ngIf="IsWrite">
                  <button
                    mat-icon-button
                    class="node-control-btn node-edit"
                    aria-label="Edit item"
                    (click)="openEditGroupModel(node)"
                    *ngIf="node.Level != 'Group'"
                  >
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.5 7.62527V9.50027H2.375L7.905 3.97027L6.03 2.09527L0.5 7.62527ZM9.355 2.52027C9.55 2.32527 9.55 2.01027 9.355 1.81527L8.185 0.645273C7.99 0.450273 7.675 0.450273 7.48 0.645273L6.565 1.56027L8.44 3.43527L9.355 2.52027Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button
                    mat-icon-button
                    class="node-control-btn node-create"
                    aria-label="Ceate item"
                    (click)="openaddNewGroupModel(node)"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5783 7.10211H6.91168V11.7688H5.35612V7.10211H0.689453V5.54655H5.35612V0.879883H6.91168V5.54655H11.5783V7.10211Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button
                    mat-icon-button
                    class="node-control-btn node-delete"
                    aria-label="delete item"
                    (click)="deleteGroupNode(node)"
                    *ngIf="node.Level != 'Group'"
                  >
                    <svg
                      width="8"
                      height="10"
                      viewBox="0 0 8 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.35547 0.9375H5.60547L5.10547 0.4375H2.60547L2.10547 0.9375H0.355469V1.9375H7.35547V0.9375ZM0.855469 8.4375C0.855469 8.70272 0.960826 8.95707 1.14836 9.14461C1.3359 9.33214 1.59025 9.4375 1.85547 9.4375H5.85547C6.12069 9.4375 6.37504 9.33214 6.56258 9.14461C6.75011 8.95707 6.85547 8.70272 6.85547 8.4375V2.4375H0.855469V8.4375Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <ul
                [ngClass]="
                  !treeControl.isExpanded(node)
                    ? 'node-invisible'
                    : 'node-visible'
                "
              >
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    </div>
  </div>
</div>

<!-- add new group model -->
<div
  class="sidepanel-model-wrapper add-group-item-model"
  [ngClass]="{ active: isaddNewGroupItemModelVisible }"
>
  <div class="sidepanel-close" (click)="closeaddNewGroupModel()"></div>
  <div class="model-content">
    <div class="model-top">
      <div class="d-flex align-items-center">
        <button
          mat-icon-button
          class="go-back"
          (click)="closeaddNewGroupModel()"
        >
          <div class="btn-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
                fill="#1D252C"
              />
            </svg>
          </div>
        </button>
        <h2 class="model-title">
          {{ plantgroupFormMode ? "Add New" : "Update" }}
          {{ addnewGroupModelTitle }}
        </h2>
      </div>
      <button
        mat-icon-button
        class="model-close-btn"
        aria-label="Close model"
        (click)="closeaddNewGroupModel()"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
            fill="black"
          />
        </svg>
      </button>
    </div>
    <div class="model-body">
      <form
        [formGroup]="addNewGroupItemForm"
        (ngSubmit)="
          plantgroupFormMode
            ? addNewGroupModeItemlFormSubmit()
            : editNewGroupModeItemlFormSubmit()
        "
      >
        <div class="form-group">
          <mat-form-field
            [ngClass]="{
              'is-invalid':
                addNewGroupItemForm.get('description')?.errors &&
                addNewGroupItemForm.get('description')?.touched
            }"
            appearance="fill"
            class="field-fill"
          >
            <mat-label>Desc</mat-label>
            <input
              matInput
              placeholder="Description"
              formControlName="description"
            />
          </mat-form-field>
          <p
            class="invalid-feedback"
            *ngIf="
              addNewGroupItemForm.get('description')?.touched &&
              addNewGroupItemForm.get('description')?.hasError('required')
            "
          >
            * description is required!
          </p>
        </div>
        <div class="form-group">
          <mat-form-field
            [ngClass]="{
              'is-invalid':
                addNewGroupItemForm.get('order')?.errors &&
                addNewGroupItemForm.get('order')?.touched
            }"
            appearance="fill"
            class="field-fill"
          >
            <mat-label>Order</mat-label>
            <input matInput placeholder="Order" formControlName="order" />
          </mat-form-field>
          <p
            class="invalid-feedback"
            *ngIf="
              addNewGroupItemForm.get('order')?.touched &&
              addNewGroupItemForm.get('order')?.hasError('required')
            "
          >
            * group order is required!
          </p>
        </div>
        <div class="checkbox-row">
          <div class="form-group" *ngIf="edited">
            <mat-checkbox color="accent" formControlName="optional">
              Optional
            </mat-checkbox>
          </div>
          <div class="form-group">
            <mat-checkbox color="accent" formControlName="active">
              Active
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill" class="field-fill">
            <mat-label>Remarks</mat-label>
            <textarea matInput formControlName="remarks"></textarea>
          </mat-form-field>
        </div>
        <div class="model-form-actions">
          <button
            type="button"
            class="add-btn"
            style="margin-left: 10px; margin-top: 0px"
            pTooltip="Cancel"
            tooltipPosition="top"
            (click)="closeaddNewGroupModel()"
          >
            <img
              src="assets/images/cancel.png"
              alt=""
              width="20px"
              height="20px"
            />
          </button>
          <button
            type="submit"
            class="add-btn"
            style="margin-left: 10px; margin-top: 0px"
            pTooltip="Update"
            tooltipPosition="top"
            *ngIf="!plantgroupFormMode"
          >
            <img
              src="assets/images/edit.png"
              alt=""
              width="20px"
              height="20px"
            />
          </button>
          <button
            type="submit"
            class="add-btn"
            style="margin-left: 10px; margin-top: 0px"
            pTooltip="Add"
            tooltipPosition="top"
            *ngIf="plantgroupFormMode"
            [disabled]="!addNewGroupItemForm.valid"
          >
            <img
              src="assets/images/save.png"
              alt=""
              width="20px"
              height="20px"
            />
          </button>
          <!-- <button type="button" mat-flat-button class="btn-cancel" (click)="closeaddNewGroupModel()"> Cancel
        </button>
        <button mat-flat-button color="accent" [disabled]="!addNewGroupItemForm.valid" class="btn-accent">{{plantgroupFormMode ? 'Save': 'Update'}}</button> -->
        </div>
      </form>
    </div>
  </div>
</div>
